"use strict";
// tslint:disable:max-classes-per-file
// tslint:disable:no-shadowed-variable
/**
 * @file The core binding handlers. And various other bits.
 * @copyright 2016 Microsoft Corporation.
 */
// TODO TFS:3745038 Check if each $dyn.isObservable is necessary as the functions should be getting the value of the
//                 observable from the binding handler framework.
// TODO TFS:3740413 Update all references to $dyn.ui.Control.* to reference the proper control.
var $dyn;
(function ($dyn) {
    /**
     * Localization strings
     * @readonly
     */
    Globalize.addCultureInfo("en", {
        messages: {
            Framework_No_Alt_Text: "Image",
        },
    });
    var onKeyDownEvent;
    (function (onKeyDownEvent) {
        function callKeyDownFunction(event) {
            if ($dyn.util.isShortcutKeyPressed(event, { alt: true, keyCode: $dyn.ui.KeyCodes.upArrow })) {
                var targetElement = event.target;
                if (!elementInteraction(targetElement, event)) {
                    targetElement.removeEventListener("keydown", $dyn.onKeyDownEvent.callKeyDownFunction);
                }
            }
        }
        onKeyDownEvent.callKeyDownFunction = callKeyDownFunction;
    })(onKeyDownEvent = $dyn.onKeyDownEvent || ($dyn.onKeyDownEvent = {}));
    /**
     * Wrapper for $dyn.ui.preview.
     * Used by inputs and controls.
     * @internal
     */
    var onFocusEvent;
    (function (onFocusEvent) {
        onFocusEvent._focusEventTimeout = 3000;
        /**
         * Will correctly call the Enhanced Preview or Super Tooltip. This is used to manage focus events on same elements.
         * @param event The event value.
         */
        function callFocusInFunction(event) {
            var targetElement = event.currentTarget;
            if ($dyn.util.isTooltipOnFocusEnabled()) {
                var control = $dyn.context(targetElement);
                // If the control is opted out of having a focus timer, do not start one
                if (!control || !control.optOutFocusTimer || !control.optOutFocusTimer()) {
                    targetElement.dynFocusedTimer = window.setTimeout(function () {
                        if (!elementInteraction(targetElement, event)) {
                            $dyn.onFocusEvent.clearFocusEvents(targetElement);
                        }
                    }, $dyn.onFocusEvent._focusEventTimeout);
                }
            }
        }
        onFocusEvent.callFocusInFunction = callFocusInFunction;
        /**
         * Will correctly close the Enhanced Preview or Super Tooltip. This is used to manage blur events on same elements.
         * @param event The elements value.
         */
        function callFocusOutFunction(event) {
            var targetElement = event.currentTarget;
            if (targetElement.getAttribute("dyn-data-preview")) {
                $dyn.preview.tryClosePreview(targetElement, event);
            }
            if (targetElement.getAttribute("dyn-data-fieldoptions")) {
                $dyn.fieldOptions.fieldOptionsRemove(targetElement);
            }
            if (targetElement.dynFocusedTimer) {
                window.clearTimeout(targetElement.dynFocusedTimer);
                targetElement.dynFocusedTimer = undefined;
            }
        }
        onFocusEvent.callFocusOutFunction = callFocusOutFunction;
        /**
         * Correctly clears the focus events
         * @param targetElement The DOM element.
         */
        function clearFocusEvents(targetElement) {
            if (!targetElement.hasAttribute("dyn-data-preview") && !targetElement.hasAttribute("dyn-data-supertooltip") && !targetElement.hasAttribute("dyn-data-fieldoptions")) {
                $(targetElement).off("focus", $dyn.onFocusEvent.callFocusInFunction);
                $(targetElement).off("blur", $dyn.onFocusEvent.callFocusOutFunction);
            }
        }
        onFocusEvent.clearFocusEvents = clearFocusEvents;
    })(onFocusEvent = $dyn.onFocusEvent || ($dyn.onFocusEvent = {}));
    var elementInteraction = function (targetElement, event) {
        var actionTaken = false;
        if (targetElement.hasAttribute("dyn-data-preview")) {
            actionTaken = true;
            $dyn.preview.tryOpenPreview(targetElement, event);
        }
        else if (targetElement.hasAttribute("dyn-data-supertooltip")) {
            actionTaken = true;
            $dyn.superTooltip.tryOpenSuperTooltip(targetElement);
        }
        if (targetElement.hasAttribute("dyn-data-fieldoptions")) {
            actionTaken = true;
            $dyn.fieldOptions.fieldOptionsAdd(targetElement);
        }
        if (actionTaken && targetElement.dynFocusedTimer) {
            window.clearTimeout(targetElement.dynFocusedTimer);
            targetElement.dynFocusedTimer = undefined;
        }
        return actionTaken;
    };
    /**
     * Wrapper for $dyn.ui.preview.
     * Used by the inputs.
     * @internal
     */
    var onMouseEvent;
    (function (onMouseEvent) {
        /**
         * Will correctly call the Enhanced Preview or Super Tooltip. This is used to manage mouse enter events on same elements.
         * @param event The elements value.
         */
        function callMouseEnterFunction(event) {
            var targetElement = event.currentTarget;
            if (!elementInteraction(targetElement, event)) {
                $dyn.onMouseEvent.clearMouseEvents(targetElement);
            }
        }
        onMouseEvent.callMouseEnterFunction = callMouseEnterFunction;
        /**
         * Will correctly close the Enhanced Preview or Super Tooltip. This is used to manage mouse leave events on same elements.
         * @param event The elements value.
         */
        function callMouseLeaveFunction(event) {
            var targetElement = event.currentTarget;
            if (targetElement.getAttribute("dyn-data-preview")) {
                $dyn.preview.tryClosePreview(targetElement, event);
            }
            if (targetElement.getAttribute("dyn-data-fieldoptions")) {
                $dyn.fieldOptions.fieldOptionsRemove(targetElement);
            }
        }
        onMouseEvent.callMouseLeaveFunction = callMouseLeaveFunction;
        /**
         * Correctly clears the mouse events
         * @param targetElement the dom element.
         */
        function clearMouseEvents(targetElement) {
            if (!targetElement.hasAttribute("dyn-data-preview") && !targetElement.hasAttribute("dyn-data-supertooltip") && !targetElement.hasAttribute("dyn-data-fieldoptions")) {
                $(targetElement).off("mouseenter", $dyn.onMouseEvent.callMouseEnterFunction);
                $(targetElement).off("mouseleave", $dyn.onMouseEvent.callMouseLeaveFunction);
            }
        }
        onMouseEvent.clearMouseEvents = clearMouseEvents;
    })(onMouseEvent = $dyn.onMouseEvent || ($dyn.onMouseEvent = {}));
    /**
     * Handles showing visual indicator for edit mode and also hover effects
     * @internal
     */
    var fieldOptions;
    (function (fieldOptions) {
        /**
         * Adds the edit indicator
         * @param element The DOM element to use.
         */
        function fieldOptionsAdd(element) {
            var control = $dyn.context(element);
            if (control) {
                var elRoot = control.Root;
                if (elRoot &&
                    elRoot.Style !== "Workspace" &&
                    !element.hasAttribute("disabled") &&
                    !$(element).closest(".filterDisplay-addField-flyOut")[0] &&
                    !$(element).closest(".SidePanel")[0] &&
                    !$(element).closest(".preview")[0] &&
                    !$(element).closest(".CustomFilter")[0] &&
                    !$(element).closest(".list-listMode")[0]) {
                    // are we view mode and user clicked a editable cell?
                    var activeForm_1 = $dyn.context($dyn.shell.getActiveForm());
                    if (elRoot.TypeName !== "FactBoxForm" && activeForm_1 && activeForm_1.CanSwitchViewMode() && activeForm_1.IsInViewMode() && $dyn.value(control.IsViewMode)) {
                        // add class to the field options except in FactBox's
                        var foundStatusArea = element.querySelector(".fieldOptions");
                        if (foundStatusArea) {
                            if (control.isFocused()) {
                                foundStatusArea.classList.add("fieldOptionsShowIsFocusedControl");
                            }
                            else {
                                foundStatusArea.classList.add("fieldOptionsShow");
                            }
                        }
                    }
                }
            }
        }
        fieldOptions.fieldOptionsAdd = fieldOptionsAdd;
        /**
         * Removes the edit indicator
         *
         * @param element The DOM element to use.
         */
        function fieldOptionsRemove(element) {
            // abort for FactBox elements
            var elRoot = $dyn.context(element).Root;
            if (elRoot && elRoot.TypeName !== "FactBoxForm" && elRoot.Style !== "Workspace" && !element.hasAttribute("disabled")) {
                var activeForm_2 = $dyn.context($dyn.shell.getActiveForm());
                if (activeForm_2 && activeForm_2.CanSwitchViewMode() && activeForm_2.IsInViewMode()) {
                    // remove class to the field status
                    var foundStatusArea = element.querySelector(".fieldOptionsShow");
                    if (foundStatusArea) {
                        foundStatusArea.classList.remove("fieldOptionsShow");
                    }
                    foundStatusArea = element.querySelector(".fieldOptionsShowIsFocusedControl");
                    if (foundStatusArea) {
                        foundStatusArea.classList.remove("fieldOptionsShowIsFocusedControl");
                    }
                }
            }
        }
        fieldOptions.fieldOptionsRemove = fieldOptionsRemove;
    })(fieldOptions = $dyn.fieldOptions || ($dyn.fieldOptions = {}));
    /**
     * Manages tooltips
     * @internal
     */
    // TODO TFS:3745038 Move to new file (it's okay to have small files!)
    var preview;
    (function (preview) {
        /**
         * Stores the tooltip for later retrieval.
         * @internal
         * @param element The control element.
         */
        function storeToolTip(element) {
            var titleElement = $(element).find(":input")[0];
            // this is the case for non grid and none active row grid elements
            if (!titleElement || !titleElement.getAttribute("title")) {
                // try the active row
                titleElement = element;
            }
            var title = titleElement.getAttribute("title");
            if (title) {
                titleElement.setAttribute("data-dyn-savedtooltip", title);
                titleElement.setAttribute("data-dyn-previewenabled", "true");
                titleElement.removeAttribute("title");
            }
        }
        preview.storeToolTip = storeToolTip;
        /**
         * Restores the tooltip if previously stored.
         * @internal
         * @param element The control element.
         */
        function restoreToolTip(element) {
            var titleElement = $(element).find(":input")[0];
            // this is the case for non grid and none active row grid elements
            if (!titleElement || !titleElement.getAttribute("data-dyn-savedtooltip")) {
                // try the active row
                titleElement = element;
            }
            if (titleElement) {
                var savedToolTip = titleElement.getAttribute("data-dyn-savedtooltip");
                if (savedToolTip) {
                    titleElement.setAttribute("title", savedToolTip);
                }
            }
            titleElement.removeAttribute("data-dyn-previewenabled");
        }
        preview.restoreToolTip = restoreToolTip;
        /**
         * Try to open a preview.
         * @internal
         * @param element The control element.
         * @param event The event requesting the preview to open.
         */
        function tryOpenPreview(element, event) {
            if (!element || element.getAttribute("data-dyn-canhavepreview") === "false") {
                return;
            }
            // are we already opening?
            if (element.dynHoveredTimer) {
                return;
            }
            var control = $dyn.ui.getLiveControl(element);
            var openPreview = function (isShortcut) {
                if (!control) {
                    // If the element is no longer attached to the dom then getLiveControl can return null
                    // Since the mouse leave may not happen, do clean up
                    $dyn.preview.restoreToolTip(element);
                    element.dynHoveredTimer = undefined;
                    return;
                }
                if (!control.isPreviewControlHovered) {
                    control.isPreviewControlHovered = $dyn.observable(true);
                    control.isPreviewHovered = $dyn.observable(false);
                }
                else {
                    control.isPreviewControlHovered(true);
                    control.isPreviewHovered(false);
                }
                element.dynPreviewContext = control;
                if ($dyn.value(control.CanHavePreview) && control.RequestEnhancedPreview) {
                    control.PreviewRequested = true;
                    var hoverId_1 = control.isPreviewControlHovered.valueChanged.subscribe(function (value) {
                        if (!$dyn.value(value)) {
                            $dyn.log.preview &&
                                $dyn.log.preview("Preview: isPreviewControlHovered changed %s, %s, %s", control.PreviewRequested, control.isPreviewControlHovered, control.isPreviewHovered);
                            if (control.PreviewRequested && !$dyn.value(control.isPreviewControlHovered) && !$dyn.value(control.isPreviewHovered)) {
                                $dyn.shell.previewManager.closePreview(control);
                                control.isPreviewControlHovered.valueChanged.unsubscribe(hoverId_1);
                            }
                        }
                    });
                    var canPreview = $dyn.shell.previewManager.canOpenPreview(control, element, isShortcut);
                    $dyn.log.preview && $dyn.log.preview("Preview: hovered %s", canPreview);
                    if (canPreview) {
                        // Put the flyout in a layout updating block so layout calls that get triggered during binding get batched
                        // so that the topmost layout element is the only one that gets arranged.
                        $dyn.ui.layout(true);
                        $dyn.shell.previewManager.displayPreview(control, element, isShortcut);
                        control.PreviewRequested = true;
                        $dyn.ui.layout(false);
                    }
                    else {
                        $dyn.preview.restoreToolTip(element);
                    }
                }
            };
            if (control && $dyn.value(control.CanHavePreview)) {
                $dyn.preview.storeToolTip(element);
                if (event && $dyn.util.isShortcutKeyPressed(event, { alt: true, keyCode: $dyn.ui.KeyCodes.upArrow })) {
                    openPreview(true);
                }
                else {
                    element.dynHoveredTimer = window.setTimeout(openPreview, 1000);
                }
            }
            else {
                // store the value
                element.setAttribute("data-dyn-canhavepreview", "false");
            }
        }
        preview.tryOpenPreview = tryOpenPreview;
        /**
         * Try to close a preview.
         * @internal
         * @param element The control element.
         * @param event The event requesting the preview to close.
         */
        function tryClosePreview(element, event) {
            if (element && (element.dynHoveredTimer || element.dynFocusedTimer)) {
                // clean up keydown handler on mouse leave for preview
                $(document.body).off("keydown.Preview");
                var control = element.dynPreviewContext;
                $dyn.log.verbosePreview = $dyn.log.preview;
                // if they leave the control before the timer fires clear it
                if (element.dynHoveredTimer) {
                    window.clearTimeout(element.dynHoveredTimer);
                    element.dynHoveredTimer = undefined;
                }
                if (element.dynFocusedTimer) {
                    window.clearTimeout(element.dynFocusedTimer);
                    element.dynFocusedTimer = undefined;
                }
                var restoreElement = element;
                if (control && control.element) {
                    restoreElement = control.element;
                }
                $dyn.preview.restoreToolTip(restoreElement);
                if (control) {
                    $dyn.log.preview && $dyn.log.preview("Preview: isPreviewControlHovered false");
                    control.isPreviewControlHovered(false);
                }
                else {
                    $dyn.log.preview && $dyn.log.preview("Preview: preview not open");
                }
            }
            else {
                $dyn.log.verbosePreview && $dyn.log.verbosePreview("Preview: no pending preview");
            }
        }
        preview.tryClosePreview = tryClosePreview;
    })(preview = $dyn.preview || ($dyn.preview = {}));
    /**
     * @extcontrol
     * The binding handlers connect the View provided by the HTML DOM Elements to the underlying Model containing the data.
     *
     * See $dyn.bindingHandlers.ExHandler for an example on how to create a custom binding handler, and
     * {@link https://docs.microsoft.com/en-us/dynamics365/fin-ops-core/dev-itpro/user-interface/extensible-control-programming-reference#html-framework-attributes HTML: Framework attributes}
     * on the AX Help Wiki for further understanding the binding handlers.
     */
    var bindingHandlers;
    (function (bindingHandlers) {
        /**
         * @extcontrol
         * Adds scope variables to the data context wrapper.
         * Facilitates communication between a parent and child control.
         */
        // TODO TFS:3745038 Remove extra parameter 'targetElement'
        var VarsBindingHandler = /** @class */ (function () {
            function VarsBindingHandler(targetElement) {
                this.targetElement = targetElement;
            }
            VarsBindingHandler.prototype.apply = function (scopeVars, dataContext) {
                if (scopeVars && dataContext) {
                    // tslint:disable-next-line:forin
                    for (var name_1 in scopeVars) {
                        dataContext.scopeVars[name_1] = scopeVars[name_1];
                    }
                }
            };
            VarsBindingHandler.prototype.dispose = function () { };
            return VarsBindingHandler;
        }());
        bindingHandlers.vars = function (targetElement) { return new VarsBindingHandler(targetElement); };
        /**
         * Updates the element's ID.
         */
        var IdBindingHandler = /** @class */ (function () {
            function IdBindingHandler() {
            }
            IdBindingHandler.prototype.invoke = function (targetElement, newValue) {
                targetElement.id = newValue;
            };
            return IdBindingHandler;
        }());
        bindingHandlers.id = new IdBindingHandler();
        var genericHandler = function (eventName) {
            return function (targetElement) {
                var lastApplied;
                var target = $(targetElement);
                var context = $dyn.context(targetElement);
                // tslint:disable-next-line:only-arrow-functions
                var handler = function () {
                    if (lastApplied) {
                        $dyn.value(lastApplied).apply(context, arguments);
                    }
                };
                target.on(eventName, handler);
                return {
                    apply: function (value, dataContext, binding) {
                        lastApplied = value;
                    },
                    dispose: function () {
                        target.off(eventName, handler);
                    },
                };
            };
        };
        var genericCaptureHandler = function (eventName) {
            return function (targetElement) {
                var lastApplied;
                var context = $dyn.context(targetElement);
                // tslint:disable-next-line:only-arrow-functions
                var handler = function () {
                    if (lastApplied) {
                        $dyn.value(lastApplied).apply(context, arguments);
                    }
                };
                var events = eventName.split(" ");
                for (var i = 0, len = events.length; i < len; i++) {
                    targetElement.addEventListener(events[i], handler, true);
                }
                return {
                    apply: function (value, dataContext, binding) {
                        lastApplied = value;
                    },
                    dispose: function () {
                        for (var i = 0, len = events.length; i < len; i++) {
                            targetElement.removeEventListener(events[i], handler, true);
                        }
                    },
                };
            };
        };
        /**
         * Subscribes the supplied function to the click event on the element.
         *
         * For more information on subscribing to the click event see {@link https://api.jquery.com/click/ jQuery - click()}.
         */
        var ClickBindingHandler = /** @class */ (function () {
            function ClickBindingHandler(captureMode) {
                if (captureMode === void 0) { captureMode = false; }
                this.captureMode = captureMode;
            }
            ClickBindingHandler.prototype.setup = function (targetElement, value) {
                /* Register contextmenu along with click so that right clicks are captured. */
                var handler;
                if (this.captureMode) {
                    handler = genericCaptureHandler;
                }
                else {
                    handler = genericHandler;
                }
                var clickHandler = handler("click contextmenu")(targetElement);
                var userCallBack = value;
                var captureRightClick = false;
                var preventDefault = false;
                var stopPropagation = false;
                var stopRightClickPropagation = false;
                var eventLoopTimer = 0;
                var eventLoopOn = false;
                // Starts a shell event loop
                var startEventLoop = function () {
                    if (!eventLoopOn) {
                        $dyn.shell.startExtendedEventLoop();
                        eventLoopOn = true;
                    }
                    if (eventLoopTimer) {
                        window.clearTimeout(eventLoopTimer);
                    }
                    // To allow event-loops to end deterministically in case right DOM events weren't fired, have a safe-guard timer
                    eventLoopTimer = window.setTimeout(endEventLoop, 5000);
                };
                // Ends the shell event loop if one is currently running
                var endEventLoop = function () {
                    if (eventLoopOn) {
                        $dyn.shell.endExtendedEventLoop();
                        eventLoopOn = false;
                    }
                    if (eventLoopTimer) {
                        window.clearTimeout(eventLoopTimer);
                        eventLoopTimer = 0;
                    }
                };
                var mouseUpHandler = function () {
                    endEventLoop();
                    window.removeEventListener("mouseup", mouseUpHandler, true);
                };
                var mouseDownHandler = function () {
                    startEventLoop();
                    // Handle the mouseup at the capture phase so that it has less chance to be cancelled
                    window.addEventListener("mouseup", mouseUpHandler, true);
                };
                $(targetElement).on("mousedown", mouseDownHandler);
                if (value && typeof value !== "function") {
                    userCallBack = value.callBack;
                    captureRightClick = value.captureRightClick && !$dyn.flags.useBrowserContextMenu;
                    preventDefault = value.preventDefault;
                    stopPropagation = value.stopPropagation;
                    stopRightClickPropagation = value.stopRightClickPropagation;
                }
                var role = $dyn.role(targetElement);
                var contextValue = $dyn.contextValue(role.context);
                // tslint:disable-next-line:only-arrow-functions
                var wrappedUserCallBack = function (event) {
                    if (preventDefault) {
                        event.preventDefault();
                    }
                    var isRightClick = event.which === $dyn.ui.MouseButtonCodes.rightButton;
                    var isContextMenu = event.type === "contextmenu" || isRightClick;
                    if (stopPropagation && (!isContextMenu || (isContextMenu && stopRightClickPropagation))) {
                        event.stopPropagation();
                        if (isContextMenu) {
                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("$dyn.bindingHandlers.click - right click");
                            event.preventDefault();
                        }
                        else {
                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("$dyn.bindingHandlers.click");
                        }
                    }
                    /*Only capture right clicks if the captureRightClicks option is on.*/
                    if (!isContextMenu || (captureRightClick && isContextMenu)) {
                        var setUpdating = false;
                        if (!$dyn.value($dyn.ui.updating)) {
                            $dyn.ui.updating(true); // Setting this optimizes code observing 'updating' while the handler runs.
                            $dyn.ui.layout(true);
                            setUpdating = true;
                        }
                        $dyn.getFunction(userCallBack).apply(contextValue, arguments);
                        if (setUpdating) {
                            $dyn.ui.updating(false);
                            $dyn.ui.layout(false);
                        }
                    }
                };
                clickHandler.apply(wrappedUserCallBack, contextValue);
                return { handler: clickHandler, mouseDownHandler: mouseDownHandler };
            };
            ClickBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state && state.handler && state.handler.dispose) {
                    state.handler.dispose();
                }
                $(targetElement).off("mousedown", state.mouseDownHandler);
            };
            return ClickBindingHandler;
        }());
        bindingHandlers.click = new ClickBindingHandler(false);
        /**
         * Captures the mouse click.
         * @internal
         * @see $dyn.bindingHandlers.click, but passes true to useCapture for
         * {@link https://msdn.microsoft.com/library/ff975245.aspx addEventListener()}.
         */
        bindingHandlers.captureClick = new ClickBindingHandler(true);
        /** @deprecated FinOps:162560 */
        // TODO TFS:3745038 Dead
        var ReadonlyClickEventHandler = /** @class */ (function () {
            function ReadonlyClickEventHandler() {
            }
            ReadonlyClickEventHandler.prototype.setupTemplate = function (handlerManager) {
                handlerManager.subscribeEvent("onclick", "clickCallback");
            };
            ReadonlyClickEventHandler.prototype.clickCallback = function (event, targetElement, callback, state, context) {
                $dyn.logDeprecated("$dyn.bindingHandlers.readonlyClick");
                if (callback && !event.defaultPrevented) {
                    $dyn.callFunction(callback, context, event);
                }
            };
            ReadonlyClickEventHandler.prototype.invoke = function () { };
            return ReadonlyClickEventHandler;
        }());
        bindingHandlers.readonlyClick = new ReadonlyClickEventHandler();
        var DomEventBindingHandler = /** @class */ (function () {
            function DomEventBindingHandler(name, eventName) {
                this.name = name;
                this.eventName = eventName;
                this.callbackName = name + "Callback";
                this[name + "Callback"] = function genericEventHandler(event, targetElement, callback, state, context) {
                    if (callback && !event.defaultPrevented) {
                        $dyn.callFunction(callback, context, event);
                    }
                };
            }
            DomEventBindingHandler.prototype.setupTemplate = function (handlerManager) {
                handlerManager.subscribeEvent(this.eventName, this.callbackName);
            };
            DomEventBindingHandler.prototype.invoke = function () { };
            return DomEventBindingHandler;
        }());
        // DOM Events
        /**
         * Binds the callback for the onclick DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onClick = new DomEventBindingHandler("onClick", "onclick");
        /**
         * Binds the callback for the onchange DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onChange = new DomEventBindingHandler("onChange", "onchange");
        /**
         * Binds the callback for the onkeydown DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onKeyDown = new DomEventBindingHandler("onKeyDown", "onkeydown");
        /**
         * Binds the callback for the onkeypress DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onKeyPress = new DomEventBindingHandler("onKeyPress", "onkeypress");
        /**
         * Binds the callback for the onfocusin DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onFocusIn = new DomEventBindingHandler("onFocusIn", "onfocusin");
        /**
         * Binds the callback for the onfocusout DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onFocusOut = new DomEventBindingHandler("onFocusOut", "onfocusout");
        /**
         * Binds the callback for the onblur DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onBlur = new DomEventBindingHandler("onBlur", "onblur");
        /**
         * Binds the callback for the onmouseenter DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onMouseEnter = new DomEventBindingHandler("onMouseEnter", "onmouseenter");
        /**
         * Binds the callback for the onmouseleave DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onMouseLeave = new DomEventBindingHandler("onMouseLeave", "onmouseleave");
        /**
         * Binds the callback for the onmouseup DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onMouseUp = new DomEventBindingHandler("onMouseUp", "onmouseup");
        /**
         * Binds the callback for the onmousedown DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onMouseDown = new DomEventBindingHandler("onMouseDown", "onmousedown");
        /**
         * Binds the callback for the oncut DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onCut = new DomEventBindingHandler("onCut", "oncut");
        /**
         * Binds the callback for the oncopy DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onCopy = new DomEventBindingHandler("onCopy", "oncopy");
        /**
         * Binds the callback for the onpaste DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onPaste = new DomEventBindingHandler("onPaste", "onpaste");
        /**
         * Binds the callback for the onscroll DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onScroll = new DomEventBindingHandler("onScroll", "onscroll");
        /**
         * Binds the callback for the oninput DOM event.
         * See {@link https://msdn.microsoft.com/library/ms533051.aspx MSDN Object and Events} for additional information.
         */
        bindingHandlers.onInput = new DomEventBindingHandler("onInput", "oninput");
        /**
         * Binding handler for a single jQuery event
         */
        var JQuerySingleEventBindingHandler = /** @class */ (function () {
            /**
             * Initializes a new instance of the JQueryEventBindingHandler class.
             *
             * @param eventName Name of the jQuery event to bind
             */
            function JQuerySingleEventBindingHandler(eventName) {
                this.eventName = eventName;
            }
            JQuerySingleEventBindingHandler.prototype.setup = function (targetElement) {
                var state = {};
                // tslint:disable-next-line:only-arrow-functions
                var handler = function () {
                    if (state.func) {
                        state.func.apply($dyn.context(targetElement), arguments);
                    }
                };
                state.handler = handler;
                $(targetElement).on(this.eventName, handler);
                return state;
            };
            JQuerySingleEventBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue, state) {
                state.func = newValue;
            };
            JQuerySingleEventBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state.handler) {
                    $(targetElement).off(this.eventName, state.handler);
                }
            };
            return JQuerySingleEventBindingHandler;
        }());
        // Generic jQuery events
        /**
         * Binds the callback for the keydown jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.keyDown = new JQuerySingleEventBindingHandler("keydown");
        /**
         * Binds the callback for the keypress jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.keyPress = new JQuerySingleEventBindingHandler("keypress");
        /**
         * Binds the callback for the keyup jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.keyUp = new JQuerySingleEventBindingHandler("keyup");
        /**
         * Binds the callback for the focusin jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.focusIn = new JQuerySingleEventBindingHandler("focusin");
        /**
         * Binds the callback for the focusout jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.focusOut = new JQuerySingleEventBindingHandler("focusout");
        /**
         * Binds the callback for the blur jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.blur = new JQuerySingleEventBindingHandler("blur");
        /**
         * Binds the callback for the mouseenter jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.mouseEnter = new JQuerySingleEventBindingHandler("mouseenter");
        /**
         * Binds the callback for the mouseleave jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.mouseLeave = new JQuerySingleEventBindingHandler("mouseleave");
        /**
         * Binds the callback for the mouseup jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.mouseUp = new JQuerySingleEventBindingHandler("mouseup");
        /**
         * Binds the callback for the mousedown jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.mouseDown = new JQuerySingleEventBindingHandler("mousedown");
        /**
         * Binds the callback for the cut jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.cut = new JQuerySingleEventBindingHandler("cut");
        /**
         * Binds the callback for the copy jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.copy = new JQuerySingleEventBindingHandler("copy");
        /**
         * Binds the callback for the paste jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.paste = new JQuerySingleEventBindingHandler("paste");
        /**
         * Binds the callback for the scroll jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.scroll = new JQuerySingleEventBindingHandler("scroll");
        /**
         * Binds the callback for the input jQuery event.
         * See {@link https://api.jquery.com/category/events jQuery - Events} for additional information.
         */
        bindingHandlers.input = new JQuerySingleEventBindingHandler("input");
        /**
         * Wrapper for jQuery bind and unbind.
         * See {@link https://api.jquery.com/category/events/ jQuery - Events} for additional information.
         * Used by the grid and hierarchical grid.
         */
        var JQueryEventBindingHandler = /** @class */ (function () {
            function JQueryEventBindingHandler() {
            }
            JQueryEventBindingHandler.prototype.invoke = function (targetElement, newValue, lastValue) {
                if (lastValue) {
                    Object.keys(lastValue).forEach(function (lastValueKey) {
                        $(targetElement).off(lastValueKey, lastValue[lastValueKey]);
                    });
                }
                if (newValue) {
                    Object.keys(newValue).forEach(function (newValueKey) {
                        $(targetElement).on(newValueKey, newValue[newValueKey]);
                    });
                }
            };
            JQueryEventBindingHandler.prototype.dispose = function (targetElement, state, lastValue) {
                if (lastValue) {
                    Object.keys(lastValue).forEach(function (lastValueKey) {
                        $(targetElement).off(lastValueKey, lastValue[lastValueKey]);
                    });
                }
            };
            return JQueryEventBindingHandler;
        }());
        bindingHandlers.event = new JQueryEventBindingHandler();
        /**
         * Handler for the jQuery secondaryNavigation custom event
         */
        var SecondaryNavigationBindingHandler = /** @class */ (function () {
            function SecondaryNavigationBindingHandler() {
            }
            SecondaryNavigationBindingHandler.prototype.setup = function (targetElement, data) {
                $(targetElement).on("secondaryNavigation", function (event) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    // TODO TFS:3745038 FinOps:162560 Dead function type?
                    if (data instanceof Function) {
                        data(event);
                    }
                    else if (data[event.inputMode] instanceof Function) {
                        // Assume this is a simple object with properties of 'keyboard' and 'mouse' for the respective secondaryNavigation input modes.
                        data[event.inputMode](event);
                    }
                });
            };
            SecondaryNavigationBindingHandler.prototype.dispose = function (targetElement) {
                $(targetElement).off("secondaryNavigation");
            };
            return SecondaryNavigationBindingHandler;
        }());
        bindingHandlers.secondaryNavigation = new SecondaryNavigationBindingHandler();
        /** Wrapper for the jQuery resize event */
        var ResizeBindingHandler = /** @class */ (function () {
            function ResizeBindingHandler() {
            }
            ResizeBindingHandler.prototype.setup = function (targetElement, data) {
                $(targetElement).on("resize", function (event) {
                    if (data instanceof Function) {
                        data.apply($dyn.context(targetElement), [event]);
                    }
                });
            };
            ResizeBindingHandler.prototype.dispose = function (targetElement) {
                $(targetElement).off("resize");
            };
            return ResizeBindingHandler;
        }());
        bindingHandlers.resize = new ResizeBindingHandler();
        /**
         * Wrapper for jQuery UI resizable().
         * See {@link https://api.jqueryui.com/resizable/ jQuery UI - Resizable Widget} for additional information.
         * Used by grid, hierarchical grid, and table.
         */
        var ResizableBindingHandler = /** @class */ (function () {
            function ResizableBindingHandler() {
            }
            ResizableBindingHandler.prototype.setup = function (targetElement, options) {
                var target = $(targetElement);
                if (!target.hasClass("ui-resizable") && target.closest(".repeater-template").length === 0) {
                    // Note: Do not process resizable in content-ignore blocks that represent a template.
                    target.resizable(options);
                }
            };
            ResizableBindingHandler.prototype.dispose = function (targetElement) {
                var target = $(targetElement);
                if (target.resizable("instance")) {
                    target.resizable("destroy");
                }
            };
            return ResizableBindingHandler;
        }());
        bindingHandlers.resizable = new ResizableBindingHandler();
        /**
         * Updates the aria-selected attribute and the selected class.
         */
        var SelectedBindingHandler = /** @class */ (function () {
            function SelectedBindingHandler() {
            }
            SelectedBindingHandler.prototype.invoke = function (targetElement, newValue, lastValue) {
                if (newValue) {
                    // Set the aria-selected attribute if applicable
                    if (targetElement.getAttribute("role") !== "menuitem") {
                        targetElement.setAttribute("aria-selected", "true");
                    }
                    targetElement.classList.add("selected");
                }
                else {
                    if (targetElement.getAttribute("role") !== "menuitem") {
                        targetElement.setAttribute("aria-selected", "false");
                    }
                    targetElement.classList.remove("selected");
                }
            };
            return SelectedBindingHandler;
        }());
        bindingHandlers.selected = new SelectedBindingHandler();
        var EnumAriaItemsBindingHandler = /** @class */ (function () {
            function EnumAriaItemsBindingHandler() {
            }
            EnumAriaItemsBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue) {
                if (newValue) {
                    if (newValue && newValue.length) {
                        targetElement.setAttribute("aria-valuemax", newValue.length.toString());
                        targetElement.setAttribute("aria-valuemin", "1");
                    }
                    else {
                        targetElement.removeAttribute("aria-valuemax");
                        targetElement.removeAttribute("aria-valuemin");
                    }
                }
            };
            return EnumAriaItemsBindingHandler;
        }());
        bindingHandlers.enumAriaItems = new EnumAriaItemsBindingHandler();
        var EnumAriaSelectionBindingHandler = /** @class */ (function () {
            function EnumAriaSelectionBindingHandler() {
            }
            EnumAriaSelectionBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue) {
                if (newValue !== null && newValue !== undefined) {
                    if (newValue < 0) {
                        targetElement.removeAttribute("aria-valuenow");
                        targetElement.removeAttribute("aria-valuetext");
                    }
                    else {
                        var instance = $dyn.context(targetElement);
                        // Set aria-valuenow for elements except inputs with 'combobox' role
                        var isCombobox = targetElement.getAttribute("role") === "combobox" && targetElement.tagName && targetElement.tagName.toLowerCase() === "input";
                        if (!isCombobox || !(instance && instance.hasEmptyItems())) {
                            targetElement.setAttribute("aria-valuenow", (newValue + 1).toString());
                        }
                        if (instance && $dyn.value(instance.Items)) {
                            var items = $dyn.value(instance.Items);
                            var selectedItem = items[newValue];
                            switch (typeof selectedItem) {
                                case "string":
                                    if (selectedItem) {
                                        targetElement.setAttribute("aria-valuetext", selectedItem);
                                        break;
                                    } // If selectedItem is an empty string, fall through to remove attr.
                                case "object":
                                    if ($dyn.value(selectedItem.Label)) {
                                        targetElement.setAttribute("aria-valuetext", $dyn.value(selectedItem.Label));
                                        break;
                                    } // If selectedItem.Label is an empty string, fall through to remove attr.
                                default:
                                    targetElement.removeAttribute("aria-valuetext");
                            }
                        }
                        else {
                            targetElement.removeAttribute("aria-valuetext");
                        }
                    }
                }
                else {
                    targetElement.removeAttribute("aria-valuenow");
                    targetElement.removeAttribute("aria-valuetext");
                }
            };
            return EnumAriaSelectionBindingHandler;
        }());
        bindingHandlers.enumAriaSelection = new EnumAriaSelectionBindingHandler();
        /**
         * Wrapper for the focus() method.
         *
         * See {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         * Used by pivot and vertical tabs.
         */
        var FocusBindingHandler = /** @class */ (function () {
            function FocusBindingHandler() {
            }
            FocusBindingHandler.prototype.invoke = function (targetElement, newValue) {
                // Calls targetElement.focus() when newValue is truthy, and clears the body focus correction logic plus triggering a targetElement.blur() when falsey.
                if (newValue) {
                    targetElement.focus();
                }
                else {
                    var oldValue = $dyn.shell.clearBodyFocusCorrection();
                    targetElement.blur();
                    $dyn.shell.bodyFocusCorrection = oldValue;
                }
            };
            return FocusBindingHandler;
        }());
        bindingHandlers.focus = new FocusBindingHandler();
        /** Binding handler for the setAttribute() method */
        var AttributeBindingHandler = /** @class */ (function () {
            function AttributeBindingHandler() {
            }
            AttributeBindingHandler.prototype.setup = function (targetElement, initialValue) {
                // Create an observer for evaluating attribute values
                var self = this;
                var getter = $dyn.computed(function () {
                    var values = {};
                    $.each($dyn.value(initialValue), function (name, value) {
                        values[name] = $dyn.value(value);
                    });
                    return values;
                });
                // Invoke is always going to get run after setup, so no need to update during $dyn.observe in the setup.
                getter.__skipFirstTimeFire = true;
                var lastObserver = $dyn.observe(getter, function (values) {
                    self.invoke(targetElement, values);
                });
                return [getter, lastObserver];
            };
            AttributeBindingHandler.prototype.shouldInvoke = function () {
                // Override default new-old value compare because value used is a complex object.
                return true;
            };
            AttributeBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue) {
                $.each(newValue, function (name, value) {
                    if (!oldValue || $dyn.value(value) !== $dyn.value(oldValue[name])) {
                        // Update needed
                        targetElement.setAttribute(name, $dyn.value(value));
                    }
                });
            };
            AttributeBindingHandler.prototype.dispose = function (targetElement, state) {
                for (var c in state) {
                    if (state[c].dispose) {
                        state[c].dispose();
                    }
                }
            };
            return AttributeBindingHandler;
        }());
        bindingHandlers.AttributeBindingHandler = AttributeBindingHandler;
        bindingHandlers.attr = new AttributeBindingHandler();
        /**
         * Wrapper for the style() method.
         * See {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         * Used almost exclusively by the vrtt gallery.
         */
        var StyleBindingHandler = /** @class */ (function () {
            function StyleBindingHandler() {
            }
            StyleBindingHandler.prototype.setup = function () {
                return { lastObserver: undefined };
            };
            StyleBindingHandler.prototype.invoke = function (targetElement, data, lastData, state) {
                // Dispose any last observer
                if (state.lastObserver) {
                    state.lastObserver.dispose();
                }
                // Create an observer for evaluating attribute values
                state.lastObserver = $dyn.observe(function () {
                    var values = {};
                    $.each($dyn.value(data), function (name, value) {
                        values[name] = $dyn.value(value);
                    });
                    return values;
                }, function (values) {
                    // Data is an object with various style values
                    $.each(values, function (name, value) {
                        targetElement.style[name] = value;
                    });
                });
            };
            StyleBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                var shouldExecute = true;
                if (newValue !== undefined && lastValue !== undefined && Object.keys(newValue).length === Object.keys(lastValue).length) {
                    shouldExecute = false;
                    $.each($dyn.value(newValue), function (name, value) {
                        if ($dyn.value(value) !== $dyn.value(lastValue[name])) {
                            shouldExecute = true;
                        }
                    });
                }
                return shouldExecute;
            };
            StyleBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state.lastObserver) {
                    state.lastObserver.dispose();
                    state.lastObserver = undefined;
                }
            };
            return StyleBindingHandler;
        }());
        bindingHandlers.style = new StyleBindingHandler();
        /**
         * @deprecated FinOps:162560
         */
        // TODO TFS:3745038 Dead
        var PropBindingHandler = /** @class */ (function () {
            function PropBindingHandler() {
            }
            PropBindingHandler.prototype.setup = function () {
                $dyn.logDeprecated("$dyn.bindingHandlers.prop");
                return { lastObserver: undefined };
            };
            PropBindingHandler.prototype.invoke = function (targetElement, data, lastValue, state) {
                // Dispose any last observer
                if (state.lastObserver) {
                    state.lastObserver.dispose();
                }
                // Create an observer for evaluating property values
                state.lastObserver = $dyn.observe(function () {
                    var values = {};
                    $.each($dyn.value(data), function (name, value) {
                        values[name] = $dyn.value(value);
                    });
                    return values;
                }, function (values) {
                    // Data is an object with various property values to set
                    $.each(values, function (name, value) {
                        $(targetElement).prop(name, value);
                    });
                });
            };
            PropBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                var shouldExecute = true;
                if (newValue !== undefined && lastValue !== undefined && Object.keys(newValue).length === Object.keys(lastValue).length) {
                    shouldExecute = false;
                    $.each($dyn.value(newValue), function (name, value) {
                        if ($dyn.value(value) !== $dyn.value(lastValue[name])) {
                            shouldExecute = true;
                            // TODO TFS:3745038 FinOps:162560 return false to short circuit
                        }
                    });
                }
                return shouldExecute;
            };
            PropBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state.lastObserver) {
                    state.lastObserver.dispose();
                    state.lastObserver = undefined;
                }
            };
            return PropBindingHandler;
        }());
        /**
         * @deprecated FinOps:162560
         */
        bindingHandlers.prop = new PropBindingHandler();
        /**
         * Wrapper for jQuery addClass() and removeClass() that allows only one set of classes to be active at a time.
         * See {@link https://api.jquery.com/category/manipulation/ jQuery - Manipulation} for additional information.
         */
        var ChooseCssBindingHandler = /** @class */ (function () {
            function ChooseCssBindingHandler() {
            }
            ChooseCssBindingHandler.prototype.setup = function (targetElement, initialValue) {
                var self = this;
                var state = { css: {}, firstTime: true };
                state.lastObserver = $dyn.observe(function () {
                    var values = {};
                    $.each($dyn.value(initialValue), function (name, val) {
                        var value = $dyn.value(val);
                        if (value instanceof Function) {
                            value = value();
                        }
                        $dyn.value(value.value); // Establish relationship for observability.
                        values[name] = value;
                    });
                    return values;
                }, function (values) {
                    self.setCss(targetElement, values, state);
                });
                return state;
            };
            ChooseCssBindingHandler.prototype.invoke = function (targetElement, data, lastValue, state) {
                if (!state.firstTime) {
                    this.setCss(targetElement, $dyn.peek(data), state);
                }
                else {
                    state.firstTime = false;
                }
            };
            ChooseCssBindingHandler.prototype.shouldInvoke = function () {
                return true; // optimization is in invoke.
            };
            ChooseCssBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state.lastObserver) {
                    state.lastObserver.dispose();
                }
            };
            // TODO TFS:3745038 Don't use jQuery
            /**
             * Actually updates the CSS.
             * @param targetElement The HTML Element.
             * @param values The CSS pairs.
             * @param state The state object returned from the handler's setup.
             */
            ChooseCssBindingHandler.prototype.setCss = function (targetElement, values, state) {
                $.each(values, function (name, value) {
                    var last = state.css[name];
                    if (last !== undefined) {
                        $(targetElement).removeClass(last);
                    }
                    for (var key in value.options) {
                        // why isn't this keyed so we don't have to iterate over it?
                        if (value.options[key] === $dyn.value(value.value)) {
                            $(targetElement).addClass(key);
                            state.css[name] = key;
                            break;
                        }
                    }
                });
            };
            return ChooseCssBindingHandler;
        }());
        bindingHandlers.chooseCss = new ChooseCssBindingHandler();
        /**
         * Wrapper for jQuery addClass() and removeClass().
         * See {@link https://api.jquery.com/category/manipulation/ jQuery - Manipulation} for additional information.
         * The bound object should consist of the CSS class names and boolean values to indicate their addition/removal.
         */
        var CssBindingHandler = /** @class */ (function () {
            function CssBindingHandler() {
            }
            CssBindingHandler.prototype.setup = function (targetElement, initialValue) {
                // Create an observer for evaluating attribute values
                var firstTime = true;
                var observables = [];
                $.each(initialValue, function (name, value) {
                    var obj = $dyn.observe(initialValue[name], function (value) {
                        if (!firstTime) {
                            value = $dyn.value(value);
                            // TODO TFS:3745038 Don't use jQuery
                            if (value && value !== "false") {
                                $(targetElement).addClass(name);
                            }
                            else {
                                $(targetElement).removeClass(name);
                            }
                        }
                    });
                    observables.push(obj);
                });
                firstTime = false;
                return observables;
            };
            CssBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                if (newValue === oldValue) {
                    $dyn.logError("CSS binding handler does not support passing the same complex object.");
                }
                // Override default new-old value compare because value used is a complex object.
                return true;
            };
            CssBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue, state) {
                // Data is an object a boolean flag for each class name to indicate whether to add/remove
                $.each(newValue, function (name, val) {
                    // Unwrap and store the observables so that they are basic primitives in 'newValue'. We do this so that the next time when this handler
                    // is invoked the 'oldValue' has simple primitives which correctly represent that previous values.
                    var value = $dyn.value(val);
                    newValue[name] = value;
                    if (!oldValue || value !== oldValue[name]) {
                        // TODO TFS:3745038 Don't use jQuery
                        if (value && value !== "false") {
                            $(targetElement).addClass(name);
                        }
                        else {
                            $(targetElement).removeClass(name);
                        }
                    }
                });
            };
            CssBindingHandler.prototype.dispose = function (targetElement, state) {
                for (var c in state) {
                    if (state[c].dispose) {
                        state[c].dispose();
                    }
                }
            };
            return CssBindingHandler;
        }());
        bindingHandlers.css = new CssBindingHandler();
        /**
         * CSS styles applied to the Form.
         * @internal
         */
        var GlobalStyleBindingHandler = /** @class */ (function () {
            function GlobalStyleBindingHandler() {
            }
            GlobalStyleBindingHandler.prototype.setup = function () {
                return {
                    DynGlobalStyles: {},
                };
            };
            GlobalStyleBindingHandler.prototype.shouldInvoke = function (value, lastValue) {
                if (!value && !lastValue) {
                    return false;
                }
                if ((value && !lastValue) || (!value && lastValue)) {
                    return true;
                }
                return value.css !== lastValue.css || value.active !== lastValue.active;
            };
            // TODO TFS:3745038 Don't use jQuery
            GlobalStyleBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue, state) {
                // Data is an object a boolean flag for each class name to indicate whether to add/remove
                var globalStyles = state.DynGlobalStyles;
                var entry = globalStyles[newValue.css];
                if (!entry) {
                    entry = [];
                    globalStyles[newValue.css] = entry;
                }
                if (newValue.active && newValue.active !== "false") {
                    if (entry.indexOf(targetElement) === -1) {
                        // Only add entry if not already present for this object
                        entry.push(targetElement);
                        $("body").addClass(newValue.css);
                    }
                }
                else {
                    var idx = entry.indexOf(targetElement);
                    if (idx !== -1) {
                        // Only remove entry if not already present for this object
                        entry.splice(idx, 1);
                        if (entry.length === 0) {
                            $("body").removeClass(newValue.css);
                        }
                    }
                }
            };
            return GlobalStyleBindingHandler;
        }());
        bindingHandlers.globalstyle = new GlobalStyleBindingHandler();
        /**
         * Manages the CSS 'viewMode' and 'editMode' classes.
         * Is generally always bound to $dyn.ui.Control.IsViewMode.
         * @internal
         */
        var ViewModeBindingHandler = /** @class */ (function () {
            function ViewModeBindingHandler() {
            }
            ViewModeBindingHandler.prototype.invoke = function (targetElement, newValue, lastValue) {
                if (newValue && newValue !== "false") {
                    targetElement.classList.add("viewMode");
                    targetElement.classList.remove("editMode");
                }
                else {
                    targetElement.classList.add("editMode");
                    if (lastValue !== undefined) {
                        targetElement.classList.remove("viewMode");
                    }
                }
            };
            return ViewModeBindingHandler;
        }());
        bindingHandlers.viewMode = new ViewModeBindingHandler();
        /**
         * Wrapper for .textContent()
         * See {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         */
        var TextBindingHandler = /** @class */ (function () {
            function TextBindingHandler() {
            }
            TextBindingHandler.prototype.invoke = function (targetElement, newValue) {
                var text = newValue;
                var emptyStr = "";
                if ($.isPlainObject(newValue)) {
                    text = $dyn.value(newValue.text);
                    if (newValue.emptyStr !== undefined) {
                        emptyStr = $dyn.value(newValue).emptyStr;
                    }
                }
                if (!text || text === "") {
                    text = emptyStr;
                }
                targetElement.textContent = text;
            };
            return TextBindingHandler;
        }());
        bindingHandlers.text = new TextBindingHandler();
        /**
         * Wrapper for .style['width'] and .style['height']
         * See {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         */
        var SingleSizingBindingHandler = /** @class */ (function () {
            function SingleSizingBindingHandler(item) {
                this.item = item;
            }
            SingleSizingBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                if (!$.isPlainObject(newValue)) {
                    return newValue !== lastValue;
                }
                if (newValue && lastValue) {
                    return newValue.unit !== lastValue.unit || newValue.value !== lastValue.value;
                }
                return !lastValue && !!newValue;
            };
            SingleSizingBindingHandler.prototype.invoke = function (targetElement, options) {
                if (!$.isPlainObject(options)) {
                    options = { value: options, unit: "px" };
                }
                if (!options.unit) {
                    options.unit = "px";
                }
                if (options.value) {
                    targetElement.style[this.item] = options.value + options.unit;
                }
                else {
                    targetElement.style[this.item] = "0";
                }
            };
            return SingleSizingBindingHandler;
        }());
        bindingHandlers.width = new SingleSizingBindingHandler("width");
        bindingHandlers.height = new SingleSizingBindingHandler("height");
        /**
         * Wrapper for $dyn.util.setVisibility.
         * Is generally bound to $dyn.ui.Control.Visible.
         */
        var VisibleBindingHandler = /** @class */ (function () {
            function VisibleBindingHandler() {
            }
            VisibleBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return newValue === undefined || newValue !== oldValue;
            };
            VisibleBindingHandler.prototype.invoke = function (targetElement, visible, oldValue) {
                // Running layout while binding can cause issues, so set the layout flag before doing the binding, if not already set.
                var setLayout = false;
                if (!$dyn.value($dyn.ui.layout)) {
                    $dyn.ui.layout(true);
                    setLayout = true;
                }
                var role = $dyn.role(targetElement);
                var dataContext = role.context;
                if (role) {
                    if (!role.childrenDataBound && !visible) {
                        role.shouldDataBindChildren = false;
                    }
                    else if (!role.childrenDataBound && visible) {
                        role.shouldDataBindChildren = true;
                        if (dataContext) {
                            // Updating should be set before binding.
                            var setUpdating = false;
                            if (!$dyn.value($dyn.ui.updating)) {
                                $dyn.ui.updating(true);
                                setUpdating = true;
                            }
                            role.dataBindChildren(dataContext);
                            if (role.childrenDataBound) {
                                role._setDataBound(true);
                            }
                            if (setUpdating) {
                                $dyn.ui.updating(false);
                            }
                        }
                    }
                }
                $dyn.util.setVisibility(targetElement, visible);
                if (setLayout) {
                    $dyn.ui.layout(false);
                }
            };
            return VisibleBindingHandler;
        }());
        bindingHandlers.visible = new VisibleBindingHandler();
        /**
         * Wrapper for $dyn.util.setVisibility.
         * Opposite of $dyn.bindingHandlers.visible with the exception that it does not defer the binding of children controls.
         * Used by FactBoxes.
         * @internal
         */
        var HiddenBindingHandler = /** @class */ (function () {
            function HiddenBindingHandler() {
            }
            HiddenBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return newValue === undefined || newValue !== oldValue;
            };
            HiddenBindingHandler.prototype.invoke = function (targetElement, hidden, oldValue) {
                var setLayout = false;
                if (!$dyn.value($dyn.ui.layout)) {
                    $dyn.ui.layout(true);
                    setLayout = true;
                }
                $dyn.util.setVisibility(targetElement, !hidden);
                if (setLayout) {
                    $dyn.ui.layout(false);
                }
            };
            return HiddenBindingHandler;
        }());
        bindingHandlers.hidden = new HiddenBindingHandler();
        /**
         * Sets the labels visible state
         * @internal
         */
        // TODO: resolve any type
        var ShowLabelBindingHandler = /** @class */ (function () {
            function ShowLabelBindingHandler() {
            }
            ShowLabelBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                if (!newValue || (newValue && oldValue && newValue.ShowLabel === oldValue.ShowLabel)) {
                    return false;
                }
                return true;
            };
            ShowLabelBindingHandler.prototype.invoke = function (targetElement, data, oldValue) {
                var showLabel;
                if (data.ShowLabel === undefined) {
                    // blank value should be considered as a valid value
                    if (data.Label === "" && data.AllowBlankLabel === true) {
                        showLabel = true;
                    }
                    else {
                        showLabel = !!data.Label;
                    }
                }
                else {
                    showLabel = $dyn.value(data.ShowLabel);
                }
                $dyn.util.setVisibility(targetElement, showLabel);
            };
            return ShowLabelBindingHandler;
        }());
        bindingHandlers.showLabel = new ShowLabelBindingHandler();
        /**
         * Wrapper for .value().
         * Is generally bound to $dyn.ui.Control.formattedValue.
         * @internal
         * @see {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         */
        var ValueNowBindingHandler = /** @class */ (function () {
            function ValueNowBindingHandler() {
            }
            ValueNowBindingHandler.prototype.setupTemplate = function (handlerManager) {
                handlerManager.subscribeEvent("oninput", "onValueNowInput");
                handlerManager.subscribeEvent("onkeypress", "onValueNowKeyPress");
            };
            ValueNowBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                var val = $dyn.value(newValue.value);
                var oldVal = oldValue && $dyn.value(oldValue.value);
                return val !== oldVal;
            };
            ValueNowBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue) {
                var val = $dyn.value(newValue.value);
                targetElement.value = val !== undefined ? val : "";
            };
            ValueNowBindingHandler.prototype.onValueNowInput = function (event, targetElement, currentOptions, state, context) {
                var setter = context[currentOptions.setter];
                if (setter) {
                    setter.call(context, targetElement.value, targetElement);
                }
            };
            ValueNowBindingHandler.prototype.onValueNowKeyPress = function (event, targetElement, currentOptions, state, context) {
                var setter = context[currentOptions.setter];
                if (setter) {
                    setter.call(context, targetElement.value, targetElement);
                }
            };
            // TODO TFS:3745038 Dead?
            /** @deprecated */
            ValueNowBindingHandler.prototype.setValue = function (targetElement, value) {
                // BROKEN targetElement.value = val !== undefined ? val : '';
            };
            // TODO TFS:3745038 Dead?
            /** @deprecated */
            ValueNowBindingHandler.prototype.getValue = function (targetElement) {
                return targetElement.value;
            };
            return ValueNowBindingHandler;
        }());
        bindingHandlers.valueNow = new ValueNowBindingHandler();
        /**
         * Establishes two-way communication for data-binding a value.
         * This handler must be invoked to update the value in the DOM element any time a change has occurred.
         * No implicit observability is used.
         * @internal
         */
        var BoundValueBindingHandler = /** @class */ (function () {
            function BoundValueBindingHandler() {
            }
            BoundValueBindingHandler.prototype.setup = function (targetElement, options) {
                if (options.allowEdit !== false) {
                    var $targetElement_1 = $(targetElement);
                    var allowEnter_1 = false;
                    var binder_1 = options.binder;
                    var state_1 = { changeMode: $dyn.ui.ChangeMode.modified, isUpdating: false, oldValue: undefined, focusInValue: undefined };
                    var onChange_1 = function () {
                        var newValue = targetElement.value;
                        // state.oldValue could have gotten updated by pressing 'enter' and we don't want to call the setValue twice
                        // so check if oldValue is different than the current value
                        if (newValue !== state_1.oldValue) {
                            state_1.isUpdating = false;
                            state_1.oldValue = undefined;
                            // note, we cannot set forceChange to true since in lookup scenarios forcing the setting of the backing value would
                            // prevent the use of filterValues (user would get a validation error)
                            binder_1.setValue(newValue, false);
                        }
                        else {
                            // clear the oldValue so that is updated on focus in
                            // have same code in blur in case change doesn't fire
                            state_1.oldValue = undefined;
                        }
                    };
                    var onFocusIn_1 = function () {
                        if (!state_1.isUpdating && !targetElement.readOnly) {
                            if (state_1.oldValue === undefined) {
                                state_1.oldValue = targetElement.value;
                            }
                            if (state_1.focusInValue === undefined) {
                                state_1.focusInValue = targetElement.value;
                            }
                        }
                    };
                    var onKeyDown_1 = function (e) {
                        if (!targetElement.readOnly && (!binder_1.shouldExecute || binder_1.shouldExecute(e, allowEnter_1))) {
                            var newValue = targetElement.value;
                            if (newValue !== state_1.oldValue || (state_1.isUpdating && state_1.changeMode === $dyn.ui.ChangeMode.dirty)) {
                                state_1.isUpdating = false;
                                state_1.oldValue = newValue;
                                if (binder_1.performCleanup) {
                                    binder_1.performCleanup();
                                }
                                binder_1.setValue(newValue, true);
                                $targetElement_1.select();
                            }
                        }
                    };
                    var onInput_1 = function (e) {
                        state_1.isUpdating = true;
                    };
                    var onBlur_1 = function () {
                        var newValue = targetElement.value;
                        if (newValue === state_1.focusInValue) {
                            // if focusInValue == blurValue then change event isn't fired
                            if (newValue !== state_1.oldValue || (state_1.isUpdating && state_1.changeMode === $dyn.ui.ChangeMode.dirty)) {
                                state_1.isUpdating = false;
                                state_1.oldValue = undefined;
                                if (binder_1.preventForceChange && binder_1.preventForceChange()) {
                                    binder_1.setValue(newValue, false);
                                }
                                else {
                                    binder_1.setValue(newValue, true);
                                }
                            }
                            else {
                                // clear out oldValue so that it is updated on focus in
                                state_1.oldValue = undefined;
                            }
                        }
                        state_1.focusInValue = undefined;
                    };
                    binder_1.notifyCommitted = function () {
                        state_1.oldValue = targetElement.value;
                        state_1.isUpdating = false;
                    };
                    state_1.changeMode = options.changeMode || $dyn.ui.ChangeMode.modified;
                    allowEnter_1 = options.allowEnter || allowEnter_1;
                    $targetElement_1.on("change.boundValue", onChange_1);
                    $targetElement_1.on("input.boundValue", onInput_1);
                    $targetElement_1.on("keydown.boundValue", onKeyDown_1);
                    $targetElement_1.on("focusin.boundValue", onFocusIn_1);
                    $targetElement_1.on("blur.boundValue", onBlur_1);
                    return state_1;
                }
                return undefined;
            };
            BoundValueBindingHandler.prototype.shouldInvoke = function (newValue, oldValue, state, targetElement) {
                if (newValue.binder === undefined) {
                    return false;
                }
                // Do this so the literal value is stored in the 'oldValue' for the next call.
                newValue.value = newValue.binder.getValue();
                var shouldInvoke = false;
                if (oldValue === undefined) {
                    // first time invoking so return true
                    shouldInvoke = true;
                }
                else if (state.oldValue !== undefined) {
                    // if control is currently focused it will have a state.oldValue, so compare with that
                    // state.oldValue will be the same as the targetElement.value unless the user is currently editing, which we do not invoke in that case anyways
                    shouldInvoke = (newValue.value !== state.oldValue);
                }
                else {
                    // otherwise compare with the oldValue we stored on the previous shouldInvoke call
                    shouldInvoke = (newValue.value !== oldValue.value);
                }
                return shouldInvoke;
            };
            BoundValueBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue, state) {
                if (newValue && newValue.binder && !state.isUpdating) {
                    var boundValue_1 = newValue.binder.getValue();
                    var shownValue = boundValue_1 !== undefined ? boundValue_1 : "";
                    targetElement.value = shownValue;
                    // use targetElement.value after this because shownValue may contain special characters (i.e. newline)
                    // that an HTML input tag does not support so targetElement.value will have those stripped out
                    if (state.oldValue !== undefined) {
                        // if the binding handler's state contains an oldValue (which is set in focusIn)
                        // we should update it here since we updated the targetElement.value
                        state.oldValue = targetElement.value;
                    }
                    if (document.activeElement === targetElement) {
                        $dyn.ui.selectionStart(targetElement, 0);
                        $dyn.ui.selectionEnd(targetElement, targetElement.value.length);
                    }
                }
            };
            BoundValueBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state) {
                    var $targetElement = $(targetElement);
                    $targetElement.off(".boundValue");
                }
            };
            return BoundValueBindingHandler;
        }());
        bindingHandlers.boundValue = new BoundValueBindingHandler();
        /**
         * Used a lot by the vrtt galleries with few product uses.
         * @internal
         */
        // Parameters:
        //   value: <value>
        //   value: { value: <value>, changeMode: <value>, allowEnter: <value> }
        //      changeMode is of enum $dyn.ui.ChangeMode.
        //      If not set, $dyn.ui.ChangeMode.Modified is used meaning value change event is raised only when old value and new value are different.
        //      $dyn.ui.ChangeMode.dirty means any changes to the value will raise the change.
        //      allowEnter is either true or false
        //      If not set, it will be false. What that means is that an enter key press will cause a value changed to occur if the value has been updated.
        bindingHandlers.value = function (targetElement) {
            var boundObservable;
            var $targetElement = $(targetElement);
            var changeMode = $dyn.ui.ChangeMode.modified;
            var isUpdating = false;
            var oldValue;
            var lastObserver;
            var allowEnter = false;
            var onChange = function () {
                var newValue = targetElement.value;
                if (boundObservable && newValue !== oldValue) {
                    boundObservable(newValue);
                    isUpdating = false;
                    oldValue = undefined;
                }
            };
            var onFocusIn = function () {
                if (!oldValue && !isUpdating && !targetElement.readOnly) {
                    oldValue = targetElement.value;
                }
            };
            var onDirtyKeyDown = function (e) {
                if (!targetElement.readOnly) {
                    var ctrlModifier = e.ctrlKey || e.metaKey || false;
                    if (!allowEnter && e.which === $dyn.ui.KeyCodes.enter) {
                        var newValue = targetElement.value;
                        if (boundObservable && (isUpdating || newValue !== oldValue)) {
                            boundObservable(newValue, true);
                            isUpdating = false;
                            oldValue = newValue;
                        }
                    }
                    else if (!isUpdating && ((!ctrlModifier && $dyn.ui.isPrintableKeyCode(e.which)) || $dyn.ui.isChangeableKeyCombo(e))) {
                        isUpdating = true;
                    }
                }
            };
            var onModifiedKeyDown = function (e) {
                if (!targetElement.readOnly && boundObservable && !allowEnter && e.which === $dyn.ui.KeyCodes.enter) {
                    boundObservable(targetElement.value);
                }
            };
            var onBlur = function () {
                var newValue = targetElement.value;
                if (isUpdating && boundObservable && newValue === oldValue) {
                    boundObservable(newValue, true);
                    isUpdating = false;
                    oldValue = undefined;
                }
            };
            return {
                apply: function (options, dataContext, observableValue) {
                    if ($.isPlainObject(options)) {
                        observableValue = options.value;
                        changeMode = options.changeMode || changeMode;
                        allowEnter = options.allowEnter || allowEnter;
                        // Dispose any last observer
                        if (lastObserver) {
                            lastObserver.dispose();
                        }
                        // Create an observer for evaluating values
                        lastObserver = $dyn.observe(observableValue, function valueChanged(newValue) {
                            // Data is set as the value on the element
                            targetElement.value = newValue !== undefined ? newValue : "";
                        });
                    }
                    else {
                        var value_1 = options;
                        // Data is set as the value on the element
                        targetElement.value = value_1 !== undefined ? value_1 : "";
                    }
                    if ($dyn.isObservable(observableValue)) {
                        boundObservable = observableValue;
                    }
                    else {
                        boundObservable = undefined;
                    }
                    // Calling .off() before calling .on() to prevent events from being bound multiple times
                    $targetElement.off("change", onChange).on("change", onChange);
                    if (changeMode === $dyn.ui.ChangeMode.dirty) {
                        $targetElement.off("focusin", onFocusIn).on("focusin", onFocusIn);
                        $targetElement.off("keydown.value").on("keydown.value", onDirtyKeyDown);
                        $targetElement.off("blur", onBlur).on("blur", onBlur);
                    }
                    else {
                        $targetElement.off("keydown.value").on("keydown.value", onModifiedKeyDown);
                    }
                },
                dispose: function () {
                    $targetElement.off("change", onChange);
                    $targetElement.off("keydown.value");
                    if (changeMode === $dyn.ui.ChangeMode.dirty) {
                        $targetElement.off("focusin", onFocusIn);
                        $targetElement.off("blur", onBlur);
                    }
                    if (lastObserver) {
                        lastObserver.dispose();
                        lastObserver = undefined;
                    }
                },
            };
        };
        /**
         * @deprecated
         */
        // TODO TFS:3745038 Dead
        bindingHandlers.selectedValue = function (targetElement) {
            $dyn.logDeprecated("$dyn.bindingHandlers.selectedValue");
            // tslint:disable-next-line: no-unnecessary-initializer
            var boundObservable = undefined;
            var onChange = function () {
                if (boundObservable) {
                    boundObservable(targetElement.options[targetElement.selectedIndex].value);
                }
            };
            targetElement.addEventListener("change", onChange);
            return {
                apply: function (data, dataContext, bindingValue) {
                    if ($dyn.isObservable(bindingValue)) {
                        boundObservable = bindingValue;
                    }
                    var value = $dyn.value(bindingValue);
                    for (var i = 0, len = targetElement.options.length; i < len; i++) {
                        var option = targetElement.options[i];
                        // tslint:disable-next-line: triple-equals
                        if (option.value == value) {
                            option.selected = true;
                        }
                    }
                },
                dispose: function () {
                    targetElement.removeEventListener("change", onChange);
                },
            };
        };
        /** @deprecated */
        // TODO TFS:3745038 Dead
        var FocusInOnMouseDownBindingHandler = /** @class */ (function () {
            function FocusInOnMouseDownBindingHandler() {
            }
            FocusInOnMouseDownBindingHandler.prototype.setup = function (targetElement) {
                $dyn.logDeprecated("$dyn.bindingHandlers.focusInOnMouseDown");
                var target = $(targetElement);
                var handler = function () {
                    target.trigger("focusin");
                };
                target.on("mousedown", handler);
                return handler;
            };
            FocusInOnMouseDownBindingHandler.prototype.dispose = function (targetElement, state) {
                $(targetElement).off("mousedown", state);
            };
            return FocusInOnMouseDownBindingHandler;
        }());
        bindingHandlers.focusInOnMouseDown = new FocusInOnMouseDownBindingHandler();
        /**
         * Wrapper for .checked and 'aria-checked' inclusion.
         * See {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         * Used by grid, checkbox, and radio button.
         */
        var CheckedBindingHandler = /** @class */ (function () {
            function CheckedBindingHandler() {
            }
            CheckedBindingHandler.prototype.setup = function (targetElement) {
                var state = { boundObservable: undefined, onChange: undefined };
                state.onChange = function () {
                    if (state.boundObservable && targetElement instanceof HTMLInputElement) {
                        state.boundObservable(targetElement.checked);
                    }
                };
                $(targetElement).on("change", state.onChange);
                return state;
            };
            CheckedBindingHandler.prototype.invoke = function (targetElement, bindingValue, lastValue, state) {
                if ($dyn.isObservable(bindingValue)) {
                    state.boundObservable = bindingValue;
                }
                var value = $dyn.value(bindingValue);
                if (typeof value === "string") {
                    value = $dyn.util.stringToBoolean(value);
                }
                if (value) {
                    targetElement.setAttribute("aria-checked", "true");
                    if (targetElement instanceof HTMLInputElement) {
                        targetElement.checked = true;
                    }
                }
                else {
                    targetElement.setAttribute("aria-checked", "false");
                    if (targetElement instanceof HTMLInputElement) {
                        targetElement.checked = false;
                    }
                }
            };
            CheckedBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                if (newValue && typeof newValue === "function" && lastValue && typeof lastValue === "function") {
                    return newValue() !== lastValue();
                }
                return newValue !== lastValue;
            };
            CheckedBindingHandler.prototype.dispose = function (targetElement, state) {
                $(targetElement).off("change", state.onChange);
            };
            return CheckedBindingHandler;
        }());
        bindingHandlers.checked = new CheckedBindingHandler();
        /**
         * Wrapper for jQuery val(). Establishes one-way data-binding of value.
         * Often used by inputs contained within a grid.
         * @internal
         * @see {@link https://api.jquery.com/val/ jQuery - val()} for additional information.
         */
        var ValueReadOnlyBindingHandler = /** @class */ (function () {
            function ValueReadOnlyBindingHandler() {
            }
            ValueReadOnlyBindingHandler.prototype.invoke = function (targetElement, value) {
                if (value === undefined) {
                    value = ""; // jQuery's val function does not support undefined. Map undefined to ''.
                }
                $(targetElement).val(value);
            };
            return ValueReadOnlyBindingHandler;
        }());
        bindingHandlers.valueReadonly = new ValueReadOnlyBindingHandler();
        /**
         * Wrapper for the 'aria-readonly' and 'readonly' attributes.
         * @internal
         * @see {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         */
        var AllowEditBindingHandler = /** @class */ (function () {
            function AllowEditBindingHandler() {
            }
            /**
             * Called when the value of the binding changes and shouldInvoke returns true.
             *
             * Sets the 'aria-readonly' and 'readonly' attribute as appropriate.
             * If the targetElement is also the currently active control changing its readonly state, re-focus the input control
             * as a workaround for an IE issue.
             *
             * - Only Inputs and TextArea support readonly attribute
             * - Only Textbox, grid and gridcell roles support aria-readonly
             * - all elements that are not input or text area will get data-dyn-readonly
             */
            AllowEditBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue) {
                var role = targetElement.getAttribute("role");
                var canTagHaveReadOnly = targetElement.tagName.toLowerCase() === "input" || targetElement.tagName.toLowerCase() === "textarea";
                var canRoleHaveAriaReadOnly = role === "textbox" || role === "grid" || role === "gridcell" || role === "checkbox";
                var ariaReadonlyForcefullyDefined = targetElement.hasAttribute("dyn-aria-readonly-forced");
                if (newValue) {
                    if (ariaReadonlyForcefullyDefined || !canTagHaveReadOnly) {
                        targetElement.removeAttribute("data-dyn-readonly");
                        if (canRoleHaveAriaReadOnly) {
                            targetElement.removeAttribute("aria-readonly");
                        }
                    }
                    else if (canTagHaveReadOnly) {
                        targetElement.removeAttribute("readonly");
                    }
                }
                else {
                    if (ariaReadonlyForcefullyDefined || !canTagHaveReadOnly) {
                        targetElement.setAttribute("data-dyn-readonly", "true");
                        if (canRoleHaveAriaReadOnly) {
                            targetElement.setAttribute("aria-readonly", "true");
                        }
                    }
                    else if (canTagHaveReadOnly) {
                        targetElement.setAttribute("readonly", "true");
                    }
                }
                // In order to workaround an IE issue that doesn't enable user interaction right away after change of
                // readonly state of an input control, we need to re-focus only if that input control is the current active
                // element.
                if (targetElement === document.activeElement && $(document.activeElement).is(":input")) {
                    var subscriberId_1;
                    var focusCallback = function () {
                        // If it's still the active element after updating has finished
                        if (targetElement === document.activeElement && $dyn.shell.isActiveWindow()) {
                            $dyn.log.focus && $dyn.log.focus("Focus: AllowEdit binding handler -> blurring and setting focus back to %s", targetElement.id);
                            var oldValue_1 = $dyn.shell.clearBodyFocusCorrection();
                            targetElement.blur();
                            targetElement.focus();
                            $(targetElement).select();
                            $dyn.shell.bodyFocusCorrection = oldValue_1;
                        }
                        if (subscriberId_1) {
                            $dyn.ui.updating.valueChanged.unsubscribe(subscriberId_1);
                        }
                    };
                    if ($dyn.value($dyn.ui.updating)) {
                        subscriberId_1 = $dyn.ui.updating.valueChanged.subscribe(focusCallback);
                    }
                    else {
                        focusCallback();
                    }
                }
            };
            return AllowEditBindingHandler;
        }());
        bindingHandlers.allowEdit = new AllowEditBindingHandler();
        /**
         * Wrapper for the 'aria-readonly' attribute.
         * Explicitly override only the 'aria-readonly' attribute to deceive the screen reader.
         * Used by combobox.
         * @internal
         */
        var AriaAllowEditBindingHandler = /** @class */ (function () {
            function AriaAllowEditBindingHandler() {
            }
            AriaAllowEditBindingHandler.prototype.invoke = function (targetElement, newValue) {
                if (newValue) {
                    targetElement.setAttribute("aria-readonly", "false");
                }
                else {
                    targetElement.setAttribute("aria-readonly", "true");
                }
                targetElement.setAttribute("dyn-aria-readonly-forced", "true");
            };
            return AriaAllowEditBindingHandler;
        }());
        bindingHandlers.ariaAllowEdit = new AriaAllowEditBindingHandler();
        /**
         * @deprecated
         */
        // TODO TFS:3745038 Dead
        var DisabledBindingHandler = /** @class */ (function () {
            function DisabledBindingHandler() {
            }
            DisabledBindingHandler.prototype.invoke = function (targetElement, newValue, lastValue) {
                $dyn.logDeprecated("$dyn.bindingHandlers.disabled");
                if (newValue) {
                    targetElement.setAttribute("disabled", "disabled");
                }
                else if (lastValue !== undefined) {
                    targetElement.removeAttribute("disabled");
                }
            };
            return DisabledBindingHandler;
        }());
        bindingHandlers.disabled = new DisabledBindingHandler();
        /**
         * Wrapper for the 'disabled' attribute.
         * @internal
         * @see {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         */
        var EnabledBindingHandler = /** @class */ (function () {
            function EnabledBindingHandler() {
            }
            EnabledBindingHandler.prototype.invoke = function (targetElement, newValue, lastValue) {
                if (!newValue) {
                    targetElement.setAttribute("disabled", "disabled");
                }
                else if (lastValue !== undefined) {
                    targetElement.removeAttribute("disabled");
                }
            };
            return EnabledBindingHandler;
        }());
        bindingHandlers.enabled = new EnabledBindingHandler();
        /**
         * Wrapper for the 'aria-disabled' attribute.
         * @internal
         */
        var AriaEnabledBindingHandler = /** @class */ (function () {
            function AriaEnabledBindingHandler() {
            }
            AriaEnabledBindingHandler.prototype.invoke = function (targetElement, newValue) {
                if (newValue) {
                    targetElement.removeAttribute("aria-disabled");
                }
                else {
                    targetElement.setAttribute("aria-disabled", "true");
                }
            };
            return AriaEnabledBindingHandler;
        }());
        bindingHandlers.ariaEnabled = new AriaEnabledBindingHandler();
        /**
         * Wrapper for a single HTML attribute
         */
        var StringHtmlAttributeBindingHandler = /** @class */ (function () {
            function StringHtmlAttributeBindingHandler(attributeName) {
                this.attributeName = attributeName;
            }
            StringHtmlAttributeBindingHandler.prototype.invoke = function (targetElement, newValue, lastValue) {
                if (newValue) {
                    // Data is set as the value on the element
                    targetElement.setAttribute(this.attributeName, newValue);
                }
                else if (lastValue) {
                    targetElement.removeAttribute(this.attributeName);
                }
            };
            return StringHtmlAttributeBindingHandler;
        }());
        /** @internal */
        bindingHandlers.href = new StringHtmlAttributeBindingHandler("href");
        /** @internal */
        bindingHandlers.target = new StringHtmlAttributeBindingHandler("target");
        /** @internal */
        bindingHandlers.Status = new StringHtmlAttributeBindingHandler("Status");
        /** @internal */
        bindingHandlers.Trend = new StringHtmlAttributeBindingHandler("Trend");
        /** @internal */
        bindingHandlers.dir = new StringHtmlAttributeBindingHandler("dir");
        /** @internal */
        bindingHandlers.Value = new StringHtmlAttributeBindingHandler("Value");
        /** @internal */
        bindingHandlers.src = new StringHtmlAttributeBindingHandler("src");
        var MaxLengthHtmlAttributeBindingHandler = /** @class */ (function () {
            function MaxLengthHtmlAttributeBindingHandler() {
            }
            MaxLengthHtmlAttributeBindingHandler.prototype.invoke = function (targetElement, newValue, lastValue) {
                newValue = parseFloat(newValue);
                lastValue = parseFloat(lastValue);
                // What about 0 should it be remove or just NaN
                if ((isNaN(newValue) || !newValue) && lastValue) {
                    targetElement.removeAttribute("maxlength");
                }
                else if (newValue) {
                    // co   newValue exists but lastValue is null
                    // Data is set as the value on the element
                    targetElement.setAttribute("maxlength", newValue.toString());
                }
            };
            return MaxLengthHtmlAttributeBindingHandler;
        }());
        /** @internal */
        bindingHandlers.maxlength = new MaxLengthHtmlAttributeBindingHandler();
        var FloatStringHtmlAttributeBindingHandler = /** @class */ (function () {
            function FloatStringHtmlAttributeBindingHandler(attributeName) {
                this.attributeName = attributeName;
            }
            FloatStringHtmlAttributeBindingHandler.prototype.invoke = function (targetElement, newValue, lastValue) {
                newValue = parseFloat(newValue);
                lastValue = parseFloat(lastValue);
                // remove only for non-numeric
                if (isNaN(newValue) && lastValue) {
                    targetElement.removeAttribute(this.attributeName);
                }
                else if (newValue >= 0) {
                    // newValue exists but lastValue is null
                    // Data is set as the value on the element
                    targetElement.setAttribute(this.attributeName, newValue.toString());
                }
            };
            return FloatStringHtmlAttributeBindingHandler;
        }());
        /** @internal */
        bindingHandlers.ariaValueNow = new FloatStringHtmlAttributeBindingHandler("aria-valuenow");
        /** @internal */
        bindingHandlers.dynValue = new FloatStringHtmlAttributeBindingHandler("data-dyn-value");
        var TruthyStringHtmlAttributeBindingHandler = /** @class */ (function () {
            function TruthyStringHtmlAttributeBindingHandler(attributeName) {
                this.attributeName = attributeName;
            }
            /**
             * Called when the value of the binding changes and shouldInvoke returns true.
             * If the first time and the value is not present, then the attribute is not set. Only updates on truthy values.
             * @param targetElement The HTML element
             * @param newValue New value of the binding
             */
            TruthyStringHtmlAttributeBindingHandler.prototype.invoke = function (targetElement, newValue) {
                if (newValue) {
                    // Data is set as the value on the element
                    targetElement.setAttribute(this.attributeName, newValue);
                }
            };
            return TruthyStringHtmlAttributeBindingHandler;
        }());
        /** @internal */
        bindingHandlers.label = new TruthyStringHtmlAttributeBindingHandler("aria-label");
        /**
         * Used by pivot and vertical tabs.
         * @internal
         */
        bindingHandlers.controlName = new TruthyStringHtmlAttributeBindingHandler("data-dyn-controlname");
        /** @internal */
        bindingHandlers.Name = new TruthyStringHtmlAttributeBindingHandler("data-dyn-form-name");
        var BooleanFlagHtmlBindingHandler = /** @class */ (function () {
            function BooleanFlagHtmlBindingHandler(attributeName) {
                this.attributeName = attributeName;
            }
            BooleanFlagHtmlBindingHandler.prototype.invoke = function (targetElement, newValue) {
                if (newValue) {
                    targetElement.setAttribute(this.attributeName, "true");
                }
                else {
                    // Data is set as the value on the element
                    targetElement.removeAttribute(this.attributeName);
                }
            };
            BooleanFlagHtmlBindingHandler.prototype.shouldInvoke = function (value, lastValue) {
                return value !== lastValue;
            };
            return BooleanFlagHtmlBindingHandler;
        }());
        /** @internal */
        bindingHandlers.required = new BooleanFlagHtmlBindingHandler("required");
        /**
         * Used by the progress bar.
         * @internal
         */
        bindingHandlers.isIndeterminate = new BooleanFlagHtmlBindingHandler("data-dyn-indeterminateprogress");
        var InvertedBooleanFlagHtmlBindingHandler = /** @class */ (function () {
            function InvertedBooleanFlagHtmlBindingHandler(attributeName) {
                this.attributeName = attributeName;
            }
            InvertedBooleanFlagHtmlBindingHandler.prototype.invoke = function (targetElement, newValue) {
                if (!newValue) {
                    targetElement.setAttribute(this.attributeName, "true");
                }
                else {
                    // Data is set as the value on the element
                    targetElement.removeAttribute(this.attributeName);
                }
            };
            InvertedBooleanFlagHtmlBindingHandler.prototype.shouldInvoke = function (value, lastValue) {
                return value !== lastValue;
            };
            return InvertedBooleanFlagHtmlBindingHandler;
        }());
        /**
         * Used by the grid and hierarchical grid.
         * @internal
         */
        bindingHandlers.showMarkColumn = new InvertedBooleanFlagHtmlBindingHandler("data-dyn-hidemarkcolumn");
        var BooleanHtmlBindingHandler = /** @class */ (function () {
            function BooleanHtmlBindingHandler(attributeName) {
                this.attributeName = attributeName;
            }
            BooleanHtmlBindingHandler.prototype.invoke = function (targetElement, value, lastValue) {
                if (value === undefined && lastValue !== undefined) {
                    targetElement.removeAttribute(this.attributeName);
                }
                else if (value && value !== "false") {
                    targetElement.setAttribute(this.attributeName, "true");
                }
                else if (value !== undefined && (!value || value === "false")) {
                    targetElement.setAttribute(this.attributeName, "false");
                }
            };
            BooleanHtmlBindingHandler.prototype.shouldInvoke = function (value, lastValue) {
                return value !== lastValue && value !== null;
            };
            return BooleanHtmlBindingHandler;
        }());
        /** @internal */
        bindingHandlers.ariaPressed = new BooleanHtmlBindingHandler("aria-pressed");
        /**
         * Used by grid, hierarchical grid, and table.
         * @internal
         */
        bindingHandlers.ariaMultiselectable = new BooleanHtmlBindingHandler("aria-multiselectable");
        // Required for back-compat
        $dyn.bindingHandlers["aria-multiselectable"] = bindingHandlers.ariaMultiselectable;
        /**
         * Wrapper for .classList that replaces the previous value.
         * @internal
         * @see {@link https://msdn.microsoft.com/library/hh772960.aspx HTML/XHTML Reference} for additional information.
         */
        bindingHandlers.extendedStyle = {
            invoke: $dyn.ui.replaceCssClass,
        };
        /**
         * Wrapper for the 'data-dynamics-input-alignment' attribute.
         * Adds 'alignment'+newValue to the classList of the targetElement and updates the 'data-dynamics-input-alignment' attribute.
         * @internal
         */
        var TextAlignBindingHandler = /** @class */ (function () {
            function TextAlignBindingHandler() {
            }
            TextAlignBindingHandler.prototype.invoke = function (targetElement, newValue) {
                if (newValue) {
                    var className = "alignment" + newValue;
                    targetElement.setAttribute("data-dynamics-input-alignment", newValue);
                    targetElement.classList.add(className);
                }
            };
            return TextAlignBindingHandler;
        }());
        bindingHandlers.textAlign = new TextAlignBindingHandler();
        /**
         * Wrapper for setting the 'type' attribute to 'password' or 'text'.
         * @internal
         */
        var PasswordHtmlAttributeBindingHandler = /** @class */ (function () {
            function PasswordHtmlAttributeBindingHandler() {
            }
            PasswordHtmlAttributeBindingHandler.prototype.invoke = function (targetElement, newValue) {
                var isCurrentPassword = targetElement.type === "password";
                if (newValue !== isCurrentPassword) {
                    if (newValue) {
                        targetElement.setAttribute("type", "password");
                    }
                    else {
                        targetElement.setAttribute("type", "text");
                    }
                }
            };
            PasswordHtmlAttributeBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return newValue !== undefined && newValue !== oldValue;
            };
            return PasswordHtmlAttributeBindingHandler;
        }());
        /** @internal */
        bindingHandlers.password = new PasswordHtmlAttributeBindingHandler();
        /**
         * Determines if the control should be in the tab sequence.
         * Wrapper for the 'tabindex' attribute.
         * @internal
         */
        var SkipBindingHandler = /** @class */ (function () {
            function SkipBindingHandler() {
            }
            /**
             * Sets the 'tabindex' attribute to -1 if the skip property is true or the enabled property is false.
             *
             * @param targetElement The HTML element
             * @param newValue New value of the binding
             */
            SkipBindingHandler.prototype.invoke = function (targetElement, options) {
                var skip = options.skip === undefined ? false : $dyn.value(options.skip);
                var enabled = options.enabled === undefined ? true : $dyn.value(options.enabled);
                var visible = options.visible === undefined ? true : $dyn.value(options.visible);
                var elementAriaHidden = targetElement.getAttribute("aria-hidden") === "true" ? true : false;
                if ((skip || !enabled) || (!visible) || elementAriaHidden) {
                    targetElement.setAttribute("tabindex", "-1");
                }
                else {
                    targetElement.setAttribute("tabindex", "0");
                }
            };
            SkipBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                if (oldValue && (($dyn.value(newValue.skip) || $dyn.value(newValue.enabled) === false) === ($dyn.value(oldValue.skip) || $dyn.value(oldValue.enabled) === false)) &&
                    ($dyn.value(newValue.visible) === $dyn.value(oldValue.visible))) {
                    return false;
                }
                return true;
            };
            return SkipBindingHandler;
        }());
        bindingHandlers.skip = new SkipBindingHandler();
        /**
         * Defines the combobox and listbox behavior for selecting a value based on the typed text.
         * Navigates the combobox and listbox dropdown based on the typed value (searching from the beginning of
         * the text) and the up and down arrows for selecting a different item.
         * @internal
         */
        var TypeToSelectBindingHandler = /** @class */ (function () {
            function TypeToSelectBindingHandler() {
                this._typeToSelectTimeoutValue = 500;
            }
            /**
             * Called once during the initial binding of the Element
             *
             * Encapsulates the type to select functionality on the keydown and keypress events. Uses prefix searching, so it only
             * matches based ont he beginning of the word. See the code (and function defined within setup) for additional information.
             * Also worth noting is the use of attaching the new $dyn.bindingHandler.typeToSelect.data to the
             * targetElement by the dynTypeToSelectOptions property.
             *
             * @param targetElement The HTML element
             */
            TypeToSelectBindingHandler.prototype.setup = function (targetElement, options) {
                var _this = this;
                if (options.checkFeature && $dyn.util.isFlightEnabled($dyn.controls.comboboxTypeAheadFeature)) {
                    return;
                }
                // TODO TFS:3745038 Follow $target naming convention
                var target = $(targetElement);
                var currentPrefix = "";
                var typeToSelectTimeoutId;
                var arrowNavigationTimeoutId;
                /**
                 * Checks if the up or down arrow were pressed and selects the appropriate item.
                 *
                 * @param event The keydown event.
                 */
                var keydown = function (event) {
                    var options = targetElement.dynTypeToSelectOptions;
                    var skipCollapsedSelection = $dyn.value(options.skipCollapsedSelection) === undefined ? false : $dyn.value(options.skipCollapsedSelection);
                    var expanded = $dyn.value(options.expanded) === undefined ? false : $dyn.value(options.expanded);
                    if (!$dyn.value(options.allowEdit)) {
                        return;
                    }
                    if ((!skipCollapsedSelection || expanded) && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.upArrow })) {
                        selectPreviousItem();
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                    else if ((!skipCollapsedSelection || expanded) && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.downArrow })) {
                        selectNextItem();
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                    else if (!skipCollapsedSelection && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.home })) {
                        selectFirstItem();
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                    else if (!skipCollapsedSelection && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.end })) {
                        selectLastItem();
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                };
                /**
                 * Updates the current prefix used for searching and cap the search/update functionality to be
                 * run after a delay (prevents every keystroke from updating). If spacebar is pressed, stop the
                 * propagation and prevent the default scrolling action.
                 *
                 * @param event The keypress event.
                 */
                var keypress = function (event) {
                    var options = targetElement.dynTypeToSelectOptions;
                    if (!$dyn.value(options.allowEdit)) {
                        return;
                    }
                    currentPrefix += String.fromCharCode(event.which);
                    // clear the timeout on each keypress and reset it. This allows for the search to happen only after the
                    // user stopped typing for a second and not for every keypress.
                    clearTimeout(typeToSelectTimeoutId);
                    typeToSelectTimeoutId = window.setTimeout(function () {
                        // the user stopped typing for a second and now we search for the next item that matches the currentPrefix
                        // and reset the currentPrefix
                        var nextItem = findNextWithPrefix(currentPrefix);
                        if (nextItem >= 0) {
                            options.selectedIndex(nextItem);
                        }
                        resetTypeToSelect();
                    }, _this._typeToSelectTimeoutValue);
                    // Incase spacebar is pressed prevent the propagation to avoid form scrolling
                    if ($dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.spacebar })) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                };
                /**
                 * Resets the current search string to an empty string.
                 */
                var resetTypeToSelect = function () {
                    currentPrefix = "";
                };
                /**
                 * Gets the next Item in Items that begins with the prefix.
                 *
                 * @param prefix The prefix to look for.
                 * @returns The index of the next element in Items that begins with the prefix.
                 */
                var findNextWithPrefix = function (prefix) {
                    var options = targetElement.dynTypeToSelectOptions;
                    var startIndex = options.shownIndex();
                    var items = options.items;
                    if (startIndex >= -1 && startIndex < items.length) {
                        var lowercasePrefix = prefix.toLocaleLowerCase();
                        // we need to find the element starting from the next element to the startIndex
                        for (var i = startIndex + 1; i < items.length; i++) {
                            if (isPrefix(lowercasePrefix, items[i])) {
                                return i;
                            }
                        }
                        for (var i = 0; i < startIndex; i++) {
                            if (isPrefix(lowercasePrefix, items[i])) {
                                return i;
                            }
                        }
                    }
                    return -1;
                };
                /**
                 * Checks whether lowercasePrefix is a prefix of label.
                 * @param lowercasePrefix The prefix to look for in label.
                 * @param option The item with a label to check for the prefix.
                 * @returns True if the label starts with lowercasePrefix.
                 */
                var isPrefix = function (lowercasePrefix, option) {
                    var lowercaseCurrentLabel = option.Label.toLocaleLowerCase();
                    return lowercaseCurrentLabel.startsWith(lowercasePrefix);
                };
                /**
                 * Selects the item after the currently selected item in the Items list.
                 */
                var selectNextItem = function () {
                    var options = targetElement.dynTypeToSelectOptions;
                    var expanded = $dyn.value(options.expanded) === undefined ? false : $dyn.value(options.expanded);
                    var nextIndex = expanded ? options.listShownIndex() + 1 : options.shownIndex() + 1;
                    if (nextIndex < options.items.length) {
                        if (expanded) {
                            options.listShownIndex(nextIndex);
                        }
                        else {
                            options.shownIndex(nextIndex);
                            updateSelectedItem(options);
                        }
                    }
                    else {
                        selectFirstItem();
                    }
                };
                /**
                 * Selects the item before the currently selected item in the Items list.
                 */
                var selectPreviousItem = function () {
                    var options = targetElement.dynTypeToSelectOptions;
                    var expanded = $dyn.value(options.expanded) === undefined ? false : $dyn.value(options.expanded);
                    var previousIndex = expanded ? options.listShownIndex() - 1 : options.shownIndex() - 1;
                    if (previousIndex >= 0) {
                        if (expanded) {
                            options.listShownIndex(previousIndex);
                        }
                        else {
                            options.shownIndex(previousIndex);
                            updateSelectedItem(options);
                        }
                    }
                    else {
                        selectLastItem();
                    }
                };
                /**
                 * Selects the first item in the Items list.
                 */
                var selectFirstItem = function () {
                    var options = targetElement.dynTypeToSelectOptions;
                    var expanded = $dyn.value(options.expanded) === undefined ? false : $dyn.value(options.expanded);
                    if (expanded) {
                        options.listShownIndex(0);
                    }
                    else {
                        options.shownIndex(0);
                        updateSelectedItem(options);
                    }
                };
                /**
                 * Selects the last item in the Items list.
                 */
                var selectLastItem = function () {
                    var options = targetElement.dynTypeToSelectOptions;
                    var expanded = $dyn.value(options.expanded) === undefined ? false : $dyn.value(options.expanded);
                    var lastIndex = $dyn.length(options.items) - 1;
                    if (expanded) {
                        options.listShownIndex(lastIndex);
                    }
                    else {
                        options.shownIndex(lastIndex);
                        updateSelectedItem(options);
                    }
                };
                /**
                 * Updates the selected item with the current display item if up or down arrow key is not pressed for 500ms.
                 * This is to avoid sending interaction with each up or down arrow press.
                 *
                 * @param options Uses selectedIndex and shownIndex.
                 */
                var updateSelectedItem = function (options) {
                    clearTimeout(arrowNavigationTimeoutId);
                    arrowNavigationTimeoutId = window.setTimeout(function () {
                        options.selectedIndex(options.shownIndex());
                    }, _this._typeToSelectTimeoutValue);
                };
                target.keydown(keydown);
                target.keypress(keypress);
                return { keydown: keydown, keypress: keypress };
            };
            TypeToSelectBindingHandler.prototype.invoke = function (targetElement, options) {
                targetElement.dynTypeToSelectOptions = options;
            };
            TypeToSelectBindingHandler.prototype.dispose = function (targetElement, state) {
                // tslint:disable-next-line:forin
                for (var func in state) {
                    // TODO TFS:3745038 Move jQuery creation out of for loop
                    $(targetElement).off(func, state[func]);
                }
                if (targetElement.dynTypeToSelectOptions) {
                    targetElement.dynTypeToSelectOptions = null;
                }
            };
            return TypeToSelectBindingHandler;
        }());
        bindingHandlers.typeToSelect = new TypeToSelectBindingHandler();
        /**
         * Defines the combobox behavior for selecting a value based on the typed text.
         * Navigates the combobox dropdown based on the typed value (filtering items as typed)
         * and the up and down arrows for selecting a different item.
         * @internal
         */
        var TypeToAutoCompleteBindingHandler = /** @class */ (function () {
            function TypeToAutoCompleteBindingHandler() {
                this._typeToAutoCompleteTimeoutValue = 500;
            }
            /**
             * Called once during the initial binding of the Element
             * Encapsulates the type to auto complete functionality on the keydown and keypress events. Uses autocomplete searching, so it
             * matches based on what the user types. See the code (and function defined within setup) for additional information.
             *
             * @param targetElement The HTML element
             */
            TypeToAutoCompleteBindingHandler.prototype.setup = function (targetElement, options) {
                var _this = this;
                if (!$dyn.util.isFlightEnabled($dyn.controls.comboboxTypeAheadFeature)) {
                    return;
                }
                var target = $(targetElement);
                var arrowNavigationTimeoutId;
                /**
                 * Checks if the up or down arrow were pressed and selects the appropriate item.
                 *
                 * @param event The keydown event.
                 */
                var keydown = function (event) {
                    var skipCollapsedSelection = $dyn.value(options.skipCollapsedSelection);
                    var expanded = $dyn.value(options.expanded);
                    if (!$dyn.value(options.allowEdit)) {
                        return;
                    }
                    // If backspace is clicked, filter down items in list
                    if (event.which === $dyn.ui.KeyCodes.backSpace) {
                        var currentText = targetElement.value;
                        if (currentText.length > 0) {
                            currentText = currentText.slice(0, -1);
                        }
                        filterItemsList(currentText, expanded);
                    }
                    if ((!skipCollapsedSelection || expanded) && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.upArrow })) {
                        selectPreviousItem();
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                    else if ((!skipCollapsedSelection || expanded) && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.downArrow })) {
                        selectNextItem();
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                    else if (!skipCollapsedSelection && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.home })) {
                        selectFirstItem();
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                    else if (!skipCollapsedSelection && $dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.end })) {
                        selectLastItem();
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                };
                /**
                 * Filters down the items based on what the user has typed so far
                 *
                 * @param event The keyup event.
                 */
                var keyup = function (event) {
                    if (!$dyn.ui.isTextualKeyEvent(event) || !$dyn.value(options.allowEdit)) {
                        return;
                    }
                    filterItemsList(targetElement.value, $dyn.value(options.expanded));
                    // Incase spacebar is pressed prevent the propagation to avoid form scrolling
                    if ($dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.spacebar })) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                };
                // Filter the items list based on text input
                var filterItemsList = function (currentText, expanded) {
                    if (!expanded) {
                        openDropDown();
                    }
                    var filteredItems = [];
                    var items = $dyn.value(options.items);
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].Label.toLocaleLowerCase().startsWith(currentText.toLocaleLowerCase())) {
                            items[i].RealIndex = i;
                            filteredItems.push(items[i]);
                        }
                    }
                    if (filteredItems.length > 0) {
                        options.listShownIndex(0);
                    }
                    options.filteredItems && options.filteredItems(filteredItems);
                    // Flyout needs to be repositioned as list is filtered
                    $dyn.flyout.flyoutManager.repositionAllFlyouts();
                };
                /**
                 * Open the drop down when user starts typing
                 */
                var openDropDown = function () {
                    if ($dyn.value(options.enabled) && $dyn.value(options.visible)) {
                        options.expanded(true);
                    }
                };
                /**
                 * Selects the item after the currently selected item in the Items list.
                 */
                var selectNextItem = function () {
                    if (options.filteredItems) {
                        var expanded = $dyn.value(options.expanded);
                        var filteredItems = $dyn.value(options.filteredItems);
                        if (!filteredItems || $dyn.value(options.items).length === filteredItems.length) {
                            var nextIndex = expanded ? options.listShownIndex() + 1 : options.shownIndex() + 1;
                            if (nextIndex < $dyn.value(options.items).length) {
                                if (expanded) {
                                    options.listShownIndex(nextIndex);
                                }
                                else {
                                    options.shownIndex(nextIndex);
                                    updateSelectedItem(options);
                                }
                            }
                            else {
                                selectFirstItem();
                            }
                        }
                        else {
                            var nextIndex = options.listShownIndex() + 1;
                            if (nextIndex < filteredItems.length) {
                                options.listShownIndex(nextIndex);
                            }
                            else {
                                selectFirstItem();
                            }
                        }
                    }
                };
                /**
                 * Selects the item before the currently selected item in the Items list.
                 */
                var selectPreviousItem = function () {
                    if (options.filteredItems) {
                        var expanded = $dyn.value(options.expanded);
                        var filteredItems = $dyn.value(options.filteredItems);
                        if (!filteredItems || $dyn.value(options.items).length === filteredItems.length) {
                            var previousIndex = expanded ? options.listShownIndex() - 1 : options.shownIndex() - 1;
                            if (previousIndex >= 0) {
                                if (expanded) {
                                    options.listShownIndex(previousIndex);
                                }
                                else {
                                    options.shownIndex(previousIndex);
                                    updateSelectedItem(options);
                                }
                            }
                            else {
                                selectLastItem();
                            }
                        }
                        else {
                            var previousIndex = options.listShownIndex() - 1;
                            if (previousIndex > -1) {
                                options.listShownIndex(previousIndex);
                            }
                            else {
                                selectLastItem();
                            }
                        }
                    }
                };
                /**
                 * Selects the first item in the Items list.
                 */
                var selectFirstItem = function () {
                    if (options.filteredItems) {
                        var expanded = $dyn.value(options.expanded);
                        var filteredItems = $dyn.value(options.filteredItems);
                        if (!filteredItems || $dyn.value(options.items).length === filteredItems.length) {
                            if (expanded) {
                                options.listShownIndex(0);
                            }
                            else {
                                options.shownIndex(0);
                                updateSelectedItem(options);
                            }
                        }
                        else {
                            options.listShownIndex(0);
                        }
                    }
                };
                /**
                 * Selects the last item in the Items list.
                 */
                var selectLastItem = function () {
                    if (options.filteredItems) {
                        var expanded = $dyn.value(options.expanded);
                        var filteredItems = $dyn.value(options.filteredItems);
                        if (!filteredItems || $dyn.value(options.items).length === filteredItems.length) {
                            var lastIndex = $dyn.length(options.items) - 1;
                            if (expanded) {
                                options.listShownIndex(lastIndex);
                            }
                            else {
                                options.shownIndex(lastIndex);
                                updateSelectedItem(options);
                            }
                        }
                        else {
                            options.listShownIndex(filteredItems.length - 1);
                        }
                    }
                };
                /**
                 * Updates the selected item with the current display item if up or down arrow key is not pressed for 500ms.
                 * This is to avoid sending interaction with each up or down arrow press.
                 *
                 * @param options Uses selectedIndex and shownIndex.
                 */
                var updateSelectedItem = function (options) {
                    clearTimeout(arrowNavigationTimeoutId);
                    arrowNavigationTimeoutId = window.setTimeout(function () {
                        options.selectedIndex(options.shownIndex());
                    }, _this._typeToAutoCompleteTimeoutValue);
                    target.val(selectedLabel());
                };
                var selectedLabel = function () {
                    var items = $dyn.value(options.items);
                    return items[$dyn.value(options.shownIndex)].Label;
                };
                target.keydown(keydown);
                target.keyup(keyup);
                return { keydown: keydown, keyup: keyup };
            };
            TypeToAutoCompleteBindingHandler.prototype.invoke = function (targetElement, options) {
                targetElement.dynTypeToAutoCompleteOptions = options;
            };
            TypeToAutoCompleteBindingHandler.prototype.dispose = function (targetElement, state) {
                // tslint:disable-next-line:forin
                for (var func in state) {
                    $(targetElement).off(func, state[func]);
                }
                if (targetElement.dynTypeToAutoCompleteOptions) {
                    targetElement.dynTypeToAutoCompleteOptions = null;
                }
            };
            return TypeToAutoCompleteBindingHandler;
        }());
        bindingHandlers.typeToAutoComplete = new TypeToAutoCompleteBindingHandler();
        /**
         * Fast grid edit version of $dyn.bindingHandlers.typeToSelect.
         * @internal
         */
        var OnTypeToSelectBindingHandler = /** @class */ (function () {
            function OnTypeToSelectBindingHandler() {
                // Bind callbacks
                this.typeToSelectKeypress = this.typeToSelectKeypress.bind(this);
                this.typeToSelectKeydown = this.typeToSelectKeydown.bind(this);
            }
            OnTypeToSelectBindingHandler.prototype.setupTemplate = function (handlerManager) {
                handlerManager.subscribeEvent("onkeypress", "typeToSelectKeypress");
                handlerManager.subscribeEvent("onkeydown", "typeToSelectKeydown");
            };
            OnTypeToSelectBindingHandler.prototype.setup = function () {
                return {
                    currentPrefix: "",
                };
            };
            OnTypeToSelectBindingHandler.prototype.typeToSelectKeypress = function (args, targetElement, options, state, context) {
                var self = this;
                if (!$dyn.value(options.allowEdit)) {
                    return;
                }
                state.currentPrefix += String.fromCharCode(args.which);
                // clear the timeout on each keypress and reset it. This allows for the search to happen only after the
                // user stopped typing for a second and not for every keypress.
                clearTimeout(state.typeToSelectTimeoutId);
                state.typeToSelectTimeoutId = window.setTimeout(function () {
                    // the user stopped typing for a second and now we search for the next item that matches the currentPrefix
                    // and reset the currentPrefix
                    var nextItem = self.findNextWithPrefix(state.currentPrefix, options);
                    if (nextItem >= 0) {
                        options.selectedIndex(nextItem);
                    }
                    self.resetTypeToSelect(state);
                }, 500);
                // Incase spacebar is pressed prevent the propagation to avoid form scrolling
                if ($dyn.util.isShortcutKeyPressed(args, { keyCode: $dyn.ui.KeyCodes.spacebar })) {
                    args.stopPropagation();
                    args.preventDefault();
                }
            };
            OnTypeToSelectBindingHandler.prototype.typeToSelectKeydown = function (args, targetElement, options, state, context) {
                // The comboBoxCellEditor is always within a grid so only do selection when the editor is expanded
                var skipSelection = !$dyn.value(options.expanded);
                if (!$dyn.value(options.allowEdit)) {
                    return;
                }
                if (!skipSelection) {
                    if ($dyn.util.isShortcutKeyPressed(args, { keyCode: $dyn.ui.KeyCodes.upArrow })) {
                        this.selectPreviousItem(options, state);
                        args.stopImmediatePropagation();
                        args.preventDefault();
                    }
                    else if ($dyn.util.isShortcutKeyPressed(args, { keyCode: $dyn.ui.KeyCodes.downArrow })) {
                        this.selectNextItem(options, state);
                        args.stopImmediatePropagation();
                        args.preventDefault();
                    }
                }
            };
            OnTypeToSelectBindingHandler.prototype.resetTypeToSelect = function (state) {
                state.currentPrefix = "";
            };
            OnTypeToSelectBindingHandler.prototype.findNextWithPrefix = function (prefix, options) {
                var startIndex = options.shownIndex();
                var items = options.items;
                if (startIndex >= -1 && startIndex < items.length) {
                    var lowercasePrefix = prefix.toLocaleLowerCase();
                    // we need to find the element starting from the next element to the startIndex
                    for (var i = startIndex + 1; i < items.length; i++) {
                        if (this.isPrefix(lowercasePrefix, items[i])) {
                            return i;
                        }
                    }
                    for (var i = 0; i < startIndex; i++) {
                        if (this.isPrefix(lowercasePrefix, items[i])) {
                            return i;
                        }
                    }
                }
                return -1;
            };
            OnTypeToSelectBindingHandler.prototype.isPrefix = function (lowercasePrefix, option) {
                var lowercaseCurrentLabel = option.Label.toLocaleLowerCase();
                return lowercaseCurrentLabel.startsWith(lowercasePrefix);
            };
            OnTypeToSelectBindingHandler.prototype.selectNextItem = function (options, state) {
                var nextIndex = options.shownIndex() + 1;
                if (nextIndex < options.items.length) {
                    options.shownIndex(nextIndex);
                    this.updateSelectedItem(options, state);
                }
            };
            OnTypeToSelectBindingHandler.prototype.selectPreviousItem = function (options, state) {
                var previousIndex = options.shownIndex() - 1;
                if (previousIndex >= 0) {
                    options.shownIndex(previousIndex);
                    this.updateSelectedItem(options, state);
                }
            };
            OnTypeToSelectBindingHandler.prototype.updateSelectedItem = function (options, state) {
                clearTimeout(state.arrowNavigationTimeoutId);
                state.arrowNavigationTimeoutId = window.setTimeout(function () {
                    options.selectedIndex(options.shownIndex());
                }, 500);
            };
            return OnTypeToSelectBindingHandler;
        }());
        bindingHandlers.OnTypeToSelectBindingHandler = OnTypeToSelectBindingHandler;
        bindingHandlers.onTypeToSelect = new OnTypeToSelectBindingHandler();
        /**
         * Wrapper for the 'hideCheckBox' class.
         * Used by the tree control to hide or show the check box.
         */
        var TreeCheckboxBindingHandler = /** @class */ (function () {
            function TreeCheckboxBindingHandler() {
            }
            TreeCheckboxBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return newValue === undefined || newValue !== oldValue;
            };
            TreeCheckboxBindingHandler.prototype.invoke = function (targetElement, checkbox) {
                if ($dyn.value(checkbox)) {
                    targetElement.classList.remove("hideCheckBox");
                }
                else {
                    targetElement.classList.add("hideCheckBox");
                }
            };
            return TreeCheckboxBindingHandler;
        }());
        bindingHandlers.treeCheckBox = new TreeCheckboxBindingHandler();
        /**
         * Binds the hyperlink behavior which can be used on objects such as inputs.
         * Used by Task Recorder.
         * @internal
         */
        var ReadonlyLinkBindingHandler = /** @class */ (function () {
            function ReadonlyLinkBindingHandler() {
                // Bind callbacks
                this.clickCallback = this.clickCallback.bind(this);
                this.mousedownCallback = this.mousedownCallback.bind(this);
                this.keyDownCallback = this.keyDownCallback.bind(this);
            }
            ReadonlyLinkBindingHandler.prototype.setupTemplate = function (handlerManager) {
                handlerManager.subscribeEvent("onclick", "clickCallback");
                handlerManager.subscribeEvent("onmousedown", "mousedownCallback");
                handlerManager.subscribeEvent("onkeydown", "keyDownCallback");
            };
            /**
             * Calls the execute method.
             * Used by $dyn.templateHandler.subscribeEvent
             * @param event The DOM click event
             * @param targetElement The HTML element
             * @param options The current options object for the binding handler
             * @param state Unused.
             * @param context Element data context
             */
            ReadonlyLinkBindingHandler.prototype.clickCallback = function (event, targetElement, options, state, context) {
                if (options && !event.defaultPrevented) {
                    this.executeLink(event, targetElement, options, state, context);
                }
            };
            /**
             * Calls the execute method if enter is pressed.
             * Used by $dyn.templateHandler.subscribeEvent
             * @param event The DOM keyboard event
             * @param targetElement The HTML element
             * @param options The current options object for the binding handler
             * @param state Unused.
             * @param context Element data context
             */
            ReadonlyLinkBindingHandler.prototype.keyDownCallback = function (event, targetElement, options, state, context) {
                if (options && !event.defaultPrevented && event.which === $dyn.ui.KeyCodes.enter) {
                    this.executeLink(event, targetElement, options, state, context);
                }
            };
            /**
             * Calls the click callback if the link is valid.
             * Used by $dyn.templateHandler.subscribeEvent
             * @param event The DOM keyboard event
             * @param targetElement The HTML element
             * @param options The current options object for the binding handler
             * @param state Unused.
             * @param context Element data context
             */
            ReadonlyLinkBindingHandler.prototype.executeLink = function (event, targetElement, options, state, context) {
                // Use the DOM state rather than the state passed in so that virtualization is supported
                if (this.getShowLink(targetElement) && $dyn.util.clickedText(targetElement)) {
                    // calling on a timeout so if there is a row change triggered it will
                    // process that before the link is processed
                    $dyn.async(function () {
                        var executeClick = true;
                        var selectionLength = $dyn.ui.selectionEnd(targetElement) - $dyn.ui.selectionStart(targetElement);
                        if (selectionLength > 0) {
                            executeClick = false;
                        }
                        if (executeClick) {
                            $dyn.callFunction(options.click, context, event);
                        }
                    }, undefined, "Hyperlink clickCallback");
                }
            };
            /**
             * Calls deselectText on the target.
             * Used by $dyn.templateHandler.subscribeEvent
             * @param event The DOM mouseDown event
             * @param targetElement The HTML element
             */
            ReadonlyLinkBindingHandler.prototype.mousedownCallback = function (event, targetElement) {
                if (event.which !== $dyn.ui.MouseButtonCodes.rightButton) {
                    $dyn.util.deselectText(targetElement);
                }
            };
            ReadonlyLinkBindingHandler.prototype.invoke = function (targetElement, options, lastOptions) {
                var lastShowLink = lastOptions && lastOptions.showLink;
                var showLink = options && options.showLink;
                if (lastShowLink !== showLink) {
                    this.setShowLink(targetElement, showLink);
                }
            };
            ReadonlyLinkBindingHandler.prototype.getShowLink = function (targetElement) {
                return targetElement.classList.contains("link-content-validLink");
            };
            ReadonlyLinkBindingHandler.prototype.setShowLink = function (targetElement, newValue) {
                if (newValue) {
                    targetElement.classList.add("link-content-validLink");
                }
                else {
                    targetElement.classList.remove("link-content-validLink");
                }
            };
            return ReadonlyLinkBindingHandler;
        }());
        bindingHandlers.readonlyLink = new ReadonlyLinkBindingHandler();
        /**
         * Binds the hyperlink behavior.
         * Handles the click, keydown, blur, and mousedown jQuery events for handling hyperlinks.
         * @internal
         */
        var LinkBindingHandler = /** @class */ (function () {
            function LinkBindingHandler() {
            }
            /**
             * Wrapper for adding/removing the 'link-content-validLink' class
             * @param targetElement The HTML element
             * @param state The current state of the binding handler
             */
            LinkBindingHandler.prototype.updateValidLinkClass = function (targetElement, state) {
                var role = $dyn.role(targetElement);
                var dataContext = role.context;
                var currentRole = targetElement.getAttribute("role");
                state.isNavigable = false;
                if (targetElement.dynLinkOptions.showLink) {
                    targetElement.classList.add("link-content-validLink");
                    if (currentRole !== "link") {
                        targetElement.setAttribute("role", "link");
                    }
                    state.isNavigable = true;
                    // For role=link aria-label or aria-labelledby are read instead of the value (not in addition to)
                    // Source: https://www.w3.org/WAI/WCAG21/Techniques/aria/ARIA7
                    if (targetElement.dynLinkOptions.byElementId) {
                        targetElement.setAttribute("aria-labelledby", targetElement.dynLinkOptions.byElementId + " " + targetElement.id);
                    }
                    else if (targetElement.dynLinkOptions.label) {
                        targetElement.setAttribute("aria-label", targetElement.dynLinkOptions.label + " " + targetElement.value);
                    }
                    if (dataContext && dataContext.current) {
                        dataContext.current.textChangedInternal = function () {
                            targetElement.dynLinkOptions.showLink = false;
                            $dyn.bindingHandlers.link.updateValidLinkClass(targetElement, state);
                        };
                    }
                }
                else {
                    if (targetElement.classList.contains("link-content-validLink")) {
                        targetElement.classList.remove("link-content-validLink");
                    }
                    var currentRole_1 = targetElement.getAttribute("role");
                    if (state.oldRole) {
                        if (state.oldRole !== currentRole_1) {
                            targetElement.setAttribute("role", state.oldRole);
                        }
                    }
                    else if (currentRole_1) {
                        targetElement.removeAttribute("role");
                    }
                    state.isNavigable = false;
                    if (targetElement.dynLinkOptions.byElementId) {
                        targetElement.setAttribute("aria-labelledby", targetElement.dynLinkOptions.byElementId);
                    }
                    else if (targetElement.dynLinkOptions.label) {
                        targetElement.setAttribute("aria-label", targetElement.dynLinkOptions.label);
                    }
                    if (dataContext && dataContext.current) {
                        dataContext.current.textChangedInternal = undefined;
                    }
                }
            };
            LinkBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                // Conditionally exist if options.showLinks and readonly hasn't changed
                if (oldValue &&
                    newValue.showLink === oldValue.showLink &&
                    newValue.readonly === oldValue.readonly &&
                    newValue.byElementId === oldValue.byElementId &&
                    newValue.label === oldValue.label) {
                    return false;
                }
                return true;
            };
            LinkBindingHandler.prototype.invoke = function (targetElement, value, lastValue, state) {
                targetElement.dynLinkOptions = value;
                this.updateValidLinkClass(targetElement, state);
            };
            LinkBindingHandler.prototype.dispose = function (targetElement, state) {
                $(targetElement).off(".link");
                if (targetElement.dynLinkOptions) {
                    targetElement.dynLinkOptions = null;
                }
            };
            // This is meant to be called once.
            LinkBindingHandler.prototype.setup = function (targetElement, options) {
                var state = { isNavigable: false };
                var $target = $(targetElement);
                targetElement.dynLinkOptions = options;
                state.oldRole = targetElement.getAttribute("role");
                // When selecting text (mousedown/drag cursor/mouseup within the same element)
                // In IE the events go mousedown/select/click
                // In Chrome the events go mousedown/click/select so a timeout is needed in this case
                //  to see if the select happened before executing the provided clicked link function
                var clickHandler = function (event) {
                    var currentOptions = targetElement.dynLinkOptions;
                    var executeClick = true;
                    var selectionLength = $dyn.ui.selectionEnd(targetElement) - $dyn.ui.selectionStart(targetElement);
                    if (selectionLength > 0) {
                        executeClick = false;
                    }
                    if ($dyn.util.clickedText(targetElement) && executeClick) {
                        $dyn.async(function () {
                            if (executeClick) {
                                var executeClickFunction_1 = function () {
                                    var linkClickedEvent = $.Event("secondaryNavigation", {
                                        inputMode: "mouse",
                                        isMetaKeyPressed: event.ctrlKey || event.metaKey,
                                    });
                                    $target.trigger(linkClickedEvent);
                                    if (state.isNavigable && !linkClickedEvent.isDefaultPrevented()) {
                                        $dyn.getFunction(currentOptions.click)();
                                    }
                                    if (linkClickedEvent.isDefaultPrevented()) {
                                        event.stopImmediatePropagation();
                                    }
                                };
                                // if there is a link triggered from a preview we need to close the open flyouts
                                var targetControl = $dyn.context(targetElement);
                                if (targetControl && targetControl.Root && targetControl.Root.IsPreviewForm) {
                                    $dyn.flyout.flyoutManager.removeAllFlyoutsAsync().done(function () {
                                        executeClickFunction_1();
                                    });
                                }
                                else {
                                    executeClickFunction_1();
                                }
                            }
                        }, 0, "linkHandler click");
                    }
                    if (currentOptions.stopPropagation) {
                        event.stopPropagation();
                    }
                };
                state.clickHandler = clickHandler;
                $target.on("click.link", state.clickHandler);
                var keydownHandler = function (evt) {
                    var currentOptions = targetElement.dynLinkOptions;
                    if (evt.which === $dyn.ui.KeyCodes.enter && (evt.ctrlKey || evt.metaKey)) {
                        // When the link element has focus and the user strikes
                        // the ENTER then treat this the same as when
                        // the user would have CLICKED on the element
                        var linkClickedEvent = $.Event("secondaryNavigation", {
                            inputMode: "keyboard",
                        });
                        $target.trigger(linkClickedEvent);
                        if (state.isNavigable && !evt.isDefaultPrevented()) {
                            $dyn.getFunction(currentOptions.click)();
                        }
                    }
                };
                state.keydownHandler = keydownHandler;
                $target.on("keydown.link", state.keydownHandler);
                var blurHandler = function (evt) {
                    $dyn.bindingHandlers.link.updateValidLinkClass(targetElement, state);
                };
                state.blurHandler = blurHandler;
                $target.on("blur.link", state.blurHandler);
                var mousedownHandler = function (evt) {
                    if (evt.which !== $dyn.ui.MouseButtonCodes.rightButton) {
                        $dyn.util.deselectText(targetElement);
                    }
                };
                state.mousedownHandler = mousedownHandler;
                $target.on("mousedown.link", state.mousedownHandler);
                // Workaround for TFS#3746882.
                // In IE11 only, when a control with the link handler is double clicked, text is not
                // selected. Instead, the cursor is moved to the beginning of the field. We are doing
                // this manually in $dyn.util.deselectText on the mousedown handler (see above).
                // Normally this is not an issue, because the dblclick event happens afterwards which
                // selects the correct text in Chrome and Edge. In IE for reasons unknown, the dblclick
                // event does not select text after selectionEnd/selectionStart is called.
                // Since IE11 click events do not properly populate the event.detail field, we don't
                // have a good way to cover triple click behavior.
                var selectTextIfReset = function (event) {
                    if ($dyn.ui.selectionEnd(targetElement) === 0 && targetElement.value) {
                        $dyn.ui.selectionStart(targetElement, 0);
                        $dyn.ui.selectionEnd(targetElement, targetElement.value.length);
                    }
                };
                targetElement.addEventListener && targetElement.addEventListener("dblclick", selectTextIfReset, false);
                return state;
            };
            return LinkBindingHandler;
        }());
        bindingHandlers.link = new LinkBindingHandler();
        /**
         * Wrapper for Element.title
         * @internal
         */
        var TitleBindingHandler = /** @class */ (function () {
            function TitleBindingHandler() {
            }
            TitleBindingHandler.prototype.invoke = function (targetElement, newValue) {
                targetElement.title = newValue;
            };
            return TitleBindingHandler;
        }());
        bindingHandlers.title = new TitleBindingHandler();
        /**
         * Sets the label for an element.
         * Uses the 'aria-labelledby' attribute.
         * @internal
         */
        var LabelForBindingHandler = /** @class */ (function () {
            function LabelForBindingHandler() {
            }
            LabelForBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return !oldValue || (newValue && (newValue.showLabel !== oldValue.showLabel || newValue.text !== oldValue.text));
            };
            /** Updates the 'aria-labelledby' attribute, the Element.textContext property, and sometimes the Element.style.display property. */
            LabelForBindingHandler.prototype.invoke = function (targetElement, options) {
                if (options) {
                    if (options.showLabel) {
                        var labelFor_1 = options.forElement;
                        labelFor_1.setAttribute("aria-labelledby", targetElement.id);
                        var labelText = options.text;
                        if (labelText) {
                            targetElement.textContent = options.text;
                        }
                        else if (options.emptyStr) {
                            targetElement.textContent = options.emptyStr;
                        }
                        if (targetElement.style.display === "none") {
                            targetElement.style.display = "";
                        }
                    }
                    else {
                        targetElement.style.display = "none";
                    }
                }
            };
            return LabelForBindingHandler;
        }());
        bindingHandlers.labelFor = new LabelForBindingHandler();
        /**
         * Sets the label for an element. Uses the 'for' attribute.
         * @internal
         */
        var AriaLabelForBindingHandler = /** @class */ (function () {
            function AriaLabelForBindingHandler() {
            }
            AriaLabelForBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return !oldValue || (newValue && (newValue.showLabel !== oldValue.showLabel || newValue.text !== oldValue.text));
            };
            AriaLabelForBindingHandler.prototype.invoke = function (targetElement, options) {
                if (options) {
                    if (options.forElementId) {
                        targetElement.setAttribute("for", options.forElementId);
                    }
                    var labelText = options.text;
                    if (labelText) {
                        targetElement.textContent = options.text;
                    }
                    else if (options.emptyStr) {
                        targetElement.textContent = options.emptyStr;
                    }
                    if (options.showLabel) {
                        if (targetElement.style.display === "none") {
                            targetElement.style.display = "";
                        }
                    }
                    else {
                        targetElement.style.display = "none";
                    }
                }
            };
            return AriaLabelForBindingHandler;
        }());
        bindingHandlers.ariaLabelFor = new AriaLabelForBindingHandler();
        /**
         * Updates the 'aria-label' attribute.
         * @internal
         */
        var AriaLabelBindingHandler = /** @class */ (function () {
            function AriaLabelBindingHandler() {
            }
            AriaLabelBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return !oldValue || (newValue && newValue.label !== oldValue.label);
            };
            AriaLabelBindingHandler.prototype.invoke = function (targetElement, options) {
                if (options) {
                    var isImage = targetElement.getAttribute("data-dyn-image-type");
                    if (options.label) {
                        targetElement.setAttribute("aria-label", options.label);
                    }
                    else {
                        if (!isImage || (isImage && !targetElement.getAttribute("aria-label"))) {
                            targetElement.removeAttribute("aria-label");
                        }
                    }
                }
            };
            return AriaLabelBindingHandler;
        }());
        bindingHandlers.ariaLabel = new AriaLabelBindingHandler();
        /**
         * Updates the 'aria-label' attribute for images
         * @internal
         */
        var AriaLabelImageBindingHandler = /** @class */ (function () {
            function AriaLabelImageBindingHandler() {
            }
            AriaLabelImageBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return !oldValue || (newValue && ((newValue.label !== oldValue.label) || (newValue.toolTip !== oldValue.toolTip)));
            };
            AriaLabelImageBindingHandler.prototype.invoke = function (targetElement, options) {
                if (options) {
                    var builtLabel = "";
                    if (options.label) {
                        targetElement.setAttribute("aria-labelledby", options.id + "_label");
                    }
                    else if (options.toolTip) {
                        builtLabel = options.toolTip;
                    }
                    else {
                        builtLabel = $dyn.label("Framework_No_Alt_Text") + " ";
                        if (options.imageName && options.type === $dyn.ui.ImageType.symbol) {
                            builtLabel += options.imageName;
                        }
                        else if (options.name) {
                            builtLabel += options.name;
                        }
                    }
                    // only image type of symbol should have an aria-label
                    if (builtLabel) {
                        targetElement.setAttribute("aria-label", builtLabel);
                    }
                    else {
                        targetElement.removeAttribute("aria-label");
                    }
                }
            };
            return AriaLabelImageBindingHandler;
        }());
        bindingHandlers.ariaLabelImage = new AriaLabelImageBindingHandler();
        /**
         * Sets the aria-labelledby attribute on an element
         * @internal
         */
        var AriaLabelledByBindingHandler = /** @class */ (function () {
            function AriaLabelledByBindingHandler() {
            }
            AriaLabelledByBindingHandler.prototype.shouldInvoke = function (newValue, oldValue) {
                return !oldValue || (newValue && newValue.byElementId !== oldValue.byElementId);
            };
            AriaLabelledByBindingHandler.prototype.invoke = function (targetElement, options) {
                var isInGrid;
                var showLabel;
                var byElementId;
                var label;
                if (options) {
                    isInGrid = options.isInGrid === undefined ? false : options.isInGrid;
                    showLabel = options.showLabel === undefined ? true : options.showLabel;
                    byElementId = options.byElementId;
                    if (options.label === undefined) {
                        var control = $dyn.context(targetElement);
                        if (control && $dyn.value(control.Label)) {
                            label = $dyn.value(control.Label);
                        }
                    }
                    else {
                        label = options.label;
                    }
                }
                // if no element passed in , clear and exit
                if (!byElementId) {
                    targetElement.removeAttribute("aria-label");
                    targetElement.removeAttribute("aria-labelledby");
                    return;
                }
                if (!isInGrid) {
                    if (showLabel) {
                        if (targetElement.hasAttribute("aria-label")) {
                            targetElement.removeAttribute("aria-label");
                        }
                        targetElement.setAttribute("aria-labelledby", byElementId);
                    }
                    else {
                        // no showlabel so use the aria-label
                        if (targetElement.hasAttribute("aria-labelledBy")) {
                            targetElement.removeAttribute("aria-labelledBy");
                        }
                        if (label) {
                            targetElement.setAttribute("aria-label", label);
                        }
                        else {
                            targetElement.setAttribute("aria-label", $dyn.label("No_LabelFound"));
                        }
                    }
                }
                else {
                    if (label) {
                        targetElement.setAttribute("aria-label", label);
                    }
                    else {
                        targetElement.setAttribute("aria-label", $dyn.label("No_LabelFound"));
                    }
                }
            };
            return AriaLabelledByBindingHandler;
        }());
        bindingHandlers.ariaLabelledBy = new AriaLabelledByBindingHandler();
        /**
         * Wrapper for the 'aria-expanded' attribute.
         * @internal
         */
        var AriaExpandedBindingHandler = /** @class */ (function () {
            function AriaExpandedBindingHandler() {
            }
            AriaExpandedBindingHandler.prototype.invoke = function (targetElement, value) {
                // tslint:disable-next-line: triple-equals
                if (value && value != "false") {
                    targetElement.setAttribute("aria-expanded", "true");
                }
                else {
                    targetElement.setAttribute("aria-expanded", "false");
                }
            };
            return AriaExpandedBindingHandler;
        }());
        bindingHandlers.ariaExpanded = new AriaExpandedBindingHandler();
        /**
         * Wrapper for the 'aria-controls' attribute.
         * @internal
         */
        var AriaControlsBindingHandler = /** @class */ (function () {
            function AriaControlsBindingHandler() {
            }
            AriaControlsBindingHandler.prototype.invoke = function (targetElement, value) {
                targetElement.setAttribute("aria-controls", value && value[0] && value[0].id);
            };
            AriaControlsBindingHandler.prototype.shouldInvoke = function (value, oldValue) {
                if (oldValue && (value && value[0] && value[0].id) === (oldValue && oldValue[0] && oldValue[0].id)) {
                    return false;
                }
                return true;
            };
            return AriaControlsBindingHandler;
        }());
        bindingHandlers.ariaControls = new AriaControlsBindingHandler();
        /**
         * Wrapper for the 'aria-level' attribute.
         * @internal
         */
        var AriaLevelBindingHandler = /** @class */ (function () {
            function AriaLevelBindingHandler() {
            }
            AriaLevelBindingHandler.prototype.invoke = function (targetElement, value) {
                var elementContext = $dyn.context(targetElement);
                // only add Level if a label exists and this is a heading
                if ($dyn.value(elementContext.Label) && targetElement.getAttribute("role") === "heading") {
                    var groupTitle = $(elementContext.element).find(".group_title");
                    if (groupTitle) {
                        // get all header elements
                        var $allHeaders = $(":header, [role='heading']");
                        var index = $allHeaders.length;
                        var headingLevel = 2; // level 1 is hard coded in the templates
                        for (var i = index - 1; i > 0; i--) {
                            var $previousHeader = $($allHeaders[i]);
                            var $parent = $previousHeader.parent();
                            // if previous header has parent container then go up to a level higher
                            if ($parent.hasClass("group_header") || $parent[0].tagName.toLocaleLowerCase() === "header") {
                                $parent = $parent.parent();
                            }
                            // if parent container contains current container
                            if ($parent.find(groupTitle).length > 0) {
                                // get level from aria-level or try parse tagName (if tagName like h1)
                                var level = parseInt($previousHeader.attr("aria-level"), 10) || parseInt($previousHeader[0].tagName.substring(1), 10);
                                if (!isNaN(level)) {
                                    headingLevel = level + 1;
                                    break;
                                }
                            }
                        }
                        targetElement.setAttribute("aria-level", headingLevel.toString());
                    }
                }
            };
            return AriaLevelBindingHandler;
        }());
        bindingHandlers.ariaLevel = new AriaLevelBindingHandler();
        /**
         * Wrapper for the flyout.
         * This binding handler is used to bind an element to open a flyout on click/keyDown?
         * @internal
         */
        var FlyoutBindingHandler = /** @class */ (function () {
            function FlyoutBindingHandler() {
            }
            FlyoutBindingHandler.prototype.setup = function (targetElement, options) {
                var isDataObject = $.isPlainObject;
                if (!isDataObject(options)) {
                    options = { flyout: options };
                }
                var flyout = options.flyout;
                // TODO TFS:3745038 Follow $target naming convention
                var target = (options.target = options.target || $(targetElement));
                var flyoutLocation = (options.of = options.of || target);
                var openOnClick = options.openOnClick === undefined ? true : options.openOnClick;
                options.moveTo = options.moveTo === undefined ? "body" : options.moveTo;
                options.optOutOfWait = options.optOutOfWait === undefined ? false : options.optOutOfWait;
                var showFlyout = (options.show = $dyn.isObservable(options.show) ? options.show : $dyn.observable(options.show));
                if (openOnClick) {
                    target[0].dynFlyout = flyout;
                    target[0].dynFlyoutLocation = flyoutLocation;
                    target[0].dynShowFlyout = showFlyout;
                }
                var buttonClick;
                var keyDown;
                if (!openOnClick) {
                    $dyn.util.flyout(options, true);
                }
                else {
                    if (flyout && flyout.length === 1) {
                        flyout[0].style.display = "none";
                    }
                    $dyn.util.flyout(options, false);
                    buttonClick = function flyout_buttonClick(event) {
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Flyout button click");
                        event.stopPropagation();
                        // This handler is responsible for clicks on the button.
                        // Added a disabled check to workaround an Edge Bug, bug is in thier bug database at: https://microsoftarchive.visualstudio.com/OS/_workitems/edit/2657124
                        if (!showFlyout() && !target.prop("disabled")) {
                            $dyn.util.flyout.clickHandler(event);
                            var control = $dyn.context(targetElement);
                            if (control) {
                                control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.mouse };
                            }
                            // Put the flyout in a layout updating block so layout calls that get triggered during binding
                            // get batched so that the topmost layout element is the only one that gets arranged.
                            $dyn.ui.layout(true);
                            showFlyout(true);
                            $dyn.ui.layout(false);
                        }
                        else {
                            $dyn.util.flyout.clickHandler(event);
                        }
                    };
                    keyDown = function flyout_keyDown(event) {
                        // This handler responds to keydown events for telemetry, and if the element is not a button,
                        // manually fires buttonClick
                        if ($dyn.util.isShortcutKeyPressed(event, { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] }) ||
                            $dyn.util.isShortcutKeyPressed(event, { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow })) {
                            var control = $dyn.context(targetElement);
                            if (control) {
                                control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                            }
                            // Button elements fire click on space or enter. If the target element is not a button
                            // (it could be a div, for example), or the user has pressed Alt+Down, call the click handler to
                            // toggle the flyout as appropriate.
                            if (!target.is("button") || $dyn.util.isShortcutKeyPressed(event, { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow })) {
                                event.preventDefault();
                                buttonClick(event);
                            }
                        }
                    };
                    options.timeoutId = window.setTimeout(function () {
                        target.click(buttonClick);
                        target.keydown(keyDown);
                        options.timeoutId = undefined;
                    });
                }
                return { options: options, buttonClick: buttonClick, keyDown: keyDown };
            };
            FlyoutBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue, state) {
                // save the timeout id so we can unsubscribe as needed
                var timeoutId = state.options.timeoutId;
                state.options = newValue; // Update in case anything changed.
                state.options.timeoutId = timeoutId;
            };
            FlyoutBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state) {
                    if (state.options) {
                        // if we have not fired the timeout clear it.
                        if (state.options.timeoutId) {
                            window.clearTimeout(state.options.timeoutId);
                        }
                        if (state.options.showSubscriber) {
                            state.options.showSubscriber.dispose();
                        }
                        if (state.options.ariaSubscriber) {
                            state.options.ariaSubscriber.dispose();
                        }
                        if (state.options.activeFlyoutSubscriber) {
                            state.options.activeFlyoutSubscriber.dispose();
                        }
                    }
                    if (state.buttonClick) {
                        $(targetElement).off("click", state.buttonClick);
                    }
                    if (state.keyDown) {
                        $(targetElement).off("keydown", state.keyDown);
                    }
                }
                targetElement.dynFlyout = null;
                targetElement.dynFlyoutLocation = null;
                targetElement.dynShowFlyout = null;
            };
            return FlyoutBindingHandler;
        }());
        bindingHandlers.flyout = new FlyoutBindingHandler();
        /**
         * Fast grid edit version of $dyn.bindingHandlers.flyout.
         * @internal
         */
        var OnFlyoutBindingHandler = /** @class */ (function () {
            function OnFlyoutBindingHandler() {
                // Bind callbacks
                this.flyoutClick = this.flyoutClick.bind(this);
                this.flyoutKeyDown = this.flyoutKeyDown.bind(this);
            }
            OnFlyoutBindingHandler.prototype.setupTemplate = function (handlerManager) {
                handlerManager.subscribeEvent("onclick", "flyoutClick");
                handlerManager.subscribeEvent("onkeydown", "flyoutKeyDown");
            };
            OnFlyoutBindingHandler.prototype.flyoutClick = function (event, targetElement, currentOptions, state) {
                event.stopPropagation();
                var options = state.options;
                var target = options.target;
                var showFlyout = options.show;
                // This handler is responsible for clicks on the button.
                // Added a disabled check to workaround an Edge Bug, bug is in thier bug database at: https://microsoftarchive.visualstudio.com/OS/_workitems/edit/2657124
                if (!showFlyout() && !target.prop("disabled")) {
                    $dyn.util.flyout.clickHandler(event);
                    var control = $dyn.context(targetElement);
                    if (control) {
                        control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.mouse };
                    }
                    // Put the flyout in a layout updating block so layout calls that get triggered during binding
                    // get batched so that the topmost layout element is the only one that gets arranged.
                    $dyn.ui.layout(true);
                    showFlyout(true);
                    $dyn.ui.layout(false);
                }
                else {
                    $dyn.util.flyout.clickHandler(event);
                }
            };
            OnFlyoutBindingHandler.prototype.flyoutKeyDown = function (event, targetElement, currentOptions, state) {
                var options = state.options;
                var target = options.target;
                // This handler responds to keydown events for telemetry, and if the element is not a button,
                // manually fires buttonClick
                if ($dyn.util.isShortcutKeyPressed(event, { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] }) ||
                    $dyn.util.isShortcutKeyPressed(event, { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow })) {
                    var control = $dyn.context(targetElement);
                    if (control) {
                        control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                    }
                    // Button elements fire click on space or enter. If the target element is not a button
                    // (it could be a div, for example), or the user has pressed Alt+Down, call the click handler to toggle the flyout as appropriate.
                    if (!target.is("button") || $dyn.util.isShortcutKeyPressed(event, { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow })) {
                        this.flyoutClick.apply(this, arguments);
                    }
                }
            };
            OnFlyoutBindingHandler.prototype.setup = function (targetElement, options) {
                var isDataObject = $.isPlainObject;
                if (!isDataObject(options)) {
                    options = { flyout: options };
                }
                var flyout = options.flyout;
                var target = (options.target = options.target || $(targetElement));
                var flyoutLocation = (options.of = options.of || target);
                var openOnClick = options.openOnClick === undefined ? true : options.openOnClick;
                options.moveTo = options.moveTo === undefined ? "body" : options.moveTo;
                options.optOutOfWait = options.optOutOfWait === undefined ? false : options.optOutOfWait;
                var showFlyout = (options.show = $dyn.isObservable(options.show) ? options.show : $dyn.observable(options.show));
                if (openOnClick) {
                    target[0].dynFlyout = flyout;
                    target[0].dynFlyoutLocation = flyoutLocation;
                    target[0].dynShowFlyout = showFlyout;
                }
                if (!openOnClick) {
                    $dyn.util.flyout(options, true);
                }
                else {
                    if (flyout && flyout.length === 1) {
                        flyout[0].style.display = "none";
                    }
                    $dyn.util.flyout(options, false);
                }
                return { options: options };
            };
            OnFlyoutBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue, state) {
                state.options = newValue; // Update in case anything changed.
            };
            OnFlyoutBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state && state.options) {
                    state.options.showSubscriber && state.options.showSubscriber.dispose();
                    state.options.activeFlyoutSubscriber && state.options.activeFlyoutSubscriber.dispose();
                }
            };
            return OnFlyoutBindingHandler;
        }());
        bindingHandlers.OnFlyoutBindingHandler = OnFlyoutBindingHandler;
        bindingHandlers.onFlyout = new OnFlyoutBindingHandler();
        /**
         * Wrapper for $dyn.ui.preview.
         * Used by the inputs.
         * @internal
         */
        var PreviewBindingHandler = /** @class */ (function () {
            function PreviewBindingHandler() {
            }
            PreviewBindingHandler.prototype.setup = function (targetElement, data) {
                if (data && data.CanHavePreview && data.RequestEnhancedPreview) {
                    targetElement.setAttribute("dyn-data-preview", "true");
                }
            };
            PreviewBindingHandler.prototype.invoke = function (targetElement, data) {
                // does this instance support previews
                // Note: that the CanHavePreview calculation is expensive so the server on the first render sends true except for a few easy
                // metadata checks that will make it false. When the preview is requested the first time the server calculates all the checks
                // and properly updates this to false if needed or renders the preview. Once set to false there is no toggling back. This would
                // be calculated on render properly and never updated except for the major perf hit so we do this staged calculation.
                if (data && data.CanHavePreview && data.RequestEnhancedPreview) {
                    $(targetElement).on("mouseenter", $dyn.onMouseEvent.callMouseEnterFunction);
                    $(targetElement).on("mouseleave", $dyn.onMouseEvent.callMouseLeaveFunction);
                    $(targetElement).on("focus", $dyn.onFocusEvent.callFocusInFunction);
                    $(targetElement).on("blur", $dyn.onFocusEvent.callFocusOutFunction);
                }
                else {
                    targetElement.removeAttribute("dyn-data-preview");
                    $dyn.onMouseEvent.clearMouseEvents(targetElement);
                    $dyn.onFocusEvent.clearFocusEvents(targetElement);
                }
            };
            PreviewBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                if (!newValue || (newValue && lastValue && newValue.CanHavePreview === lastValue.CanHavePreview && newValue.RequestEnhancedPreview === lastValue.RequestEnhancedPreview)) {
                    return false;
                }
                return true;
            };
            PreviewBindingHandler.prototype.dispose = function (targetElement) {
                targetElement.removeAttribute("dyn-data-preview");
                $dyn.onMouseEvent.clearMouseEvents(targetElement);
                if (targetElement.dynHoveredTimer) {
                    window.clearTimeout(targetElement.dynHoveredTimer);
                    targetElement.dynHoveredTimer = undefined;
                }
                if (targetElement.dynPreviewContext) {
                    targetElement.dynPreviewContext = null;
                }
            };
            return PreviewBindingHandler;
        }());
        bindingHandlers.PreviewBindingHandler = PreviewBindingHandler;
        bindingHandlers.preview = new PreviewBindingHandler();
        /**
         * Wrapper for the 'data-dyn-helptext' attribute.
         * Used by navigation bar.
         * @internal
         */
        var HelpTextBindingHandler = /** @class */ (function () {
            function HelpTextBindingHandler() {
            }
            HelpTextBindingHandler.prototype.invoke = function (targetElement, data) {
                if (data) {
                    targetElement.setAttribute("data-dyn-helptext", data);
                }
                else {
                    targetElement.removeAttribute("data-dyn-helptext");
                }
            };
            HelpTextBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                // Only invoke for truthy values.
                // TODO TFS:3745038 Bug? Don't update on new falsey and old truthy values?
                if (!newValue || (newValue && lastValue)) {
                    return false;
                }
                return true;
            };
            return HelpTextBindingHandler;
        }());
        bindingHandlers.helpText = new HelpTextBindingHandler();
        /**
         * Wrapper for $dyn.fieldOptions functionality.
         * Fires on the mouseenter events for fieldoptions
         * @internal
         */
        var FieldOptionsBindingHandler = /** @class */ (function () {
            function FieldOptionsBindingHandler() {
            }
            FieldOptionsBindingHandler.prototype.setup = function (targetElement, data) {
                if (data && !data.AllowTyping && $dyn.context(targetElement) && $dyn.context(targetElement).Root && $dyn.context(targetElement).Root.TypeName !== "FactBoxForm") {
                    targetElement.setAttribute("dyn-data-fieldoptions", "true");
                }
            };
            FieldOptionsBindingHandler.prototype.invoke = function (targetElement, data) {
                if (data && !data.AllowTyping && $dyn.context(targetElement) && $dyn.context(targetElement).Root && $dyn.context(targetElement).Root.TypeName !== "FactBoxForm") {
                    $(targetElement).on("mouseenter", $dyn.onMouseEvent.callMouseEnterFunction);
                    $(targetElement).on("mouseleave", $dyn.onMouseEvent.callMouseLeaveFunction);
                }
                else {
                    targetElement.removeAttribute("dyn-data-fieldoptions");
                    $dyn.onMouseEvent.clearMouseEvents(targetElement);
                }
            };
            FieldOptionsBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                // Only invoke for truthy values.
                // TODO TFS:3745038 Bug? Don't update on new falsey and old truthy values?
                if (!newValue || (newValue && lastValue)) {
                    return false;
                }
                return true;
            };
            FieldOptionsBindingHandler.prototype.dispose = function (targetElement) {
                targetElement.removeAttribute("dyn-data-fieldoptions");
                $dyn.onMouseEvent.clearMouseEvents(targetElement);
            };
            return FieldOptionsBindingHandler;
        }());
        bindingHandlers.fieldOptions = new FieldOptionsBindingHandler();
        /**
         * Wrapper for $dyn.ui.formHeaderCreate functionality.
         * @internal
         */
        var FormHeaderCreateBindingHandler = /** @class */ (function () {
            function FormHeaderCreateBindingHandler() {
            }
            FormHeaderCreateBindingHandler.prototype.setup = function (targetElement, data) {
                var h1 = null;
                var h2 = null;
                // Dialog will not have FormCaption or Headers
                if (data.FormType !== "Dialog") {
                    h1 = document.createElement("h1");
                    h1.classList.add("formCaption");
                    $(h1).on("click", function (event) {
                        data.HeaderClicked(event);
                    });
                    $(h1).on("keydown", function (event) {
                        if ($dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.enter })) {
                            data.HeaderClicked(event);
                        }
                    });
                    h2 = document.createElement("h2");
                    h2.classList.add("formCaption-context");
                    // always in tab sequence due to Accessibility needs to be consistent when link and not a link
                    h1.tabIndex = 0;
                    if ($dyn.util.isEnhancedTabSequenceEnabled()) {
                        h2.tabIndex = 0;
                    }
                    else {
                        h2.tabIndex = -1;
                    }
                    targetElement.appendChild(h1);
                    targetElement.appendChild(h2);
                }
                var $targetElement = $(targetElement);
                var form = $dyn.context(targetElement);
                var adjustFormHeaderAndViewSelector = function () {
                    if (h1 && $targetElement.children(".formCaption").length < 1) {
                        targetElement.appendChild(h1);
                    }
                    if (h2 && $targetElement.children(".formCaption-context").length < 1) {
                        targetElement.appendChild(h2);
                    }
                    var viewFiltersButton = $targetElement.children("[data-dyn-controlname='SystemDefinedManageViewFilters']")[0];
                    if (viewFiltersButton && form && form.adjustSystemDefinedManageViewFilters) {
                        form.adjustSystemDefinedManageViewFilters();
                    }
                };
                adjustFormHeaderAndViewSelector();
                // create an observer instance
                var observer = new MutationObserver(function (mutations) {
                    observer.disconnect();
                    adjustFormHeaderAndViewSelector();
                    observer.observe(targetElement, config);
                });
                // configuration of the observer
                var config = { childList: true };
                observer.observe(targetElement, config);
                return { h1: h1, h2: h2, mutationObserver: observer };
            };
            FormHeaderCreateBindingHandler.prototype.invoke = function (targetElement, data, lastData, state) {
                if (state && state.h1 && state.h2) {
                    state.h1.textContent = $dyn.value(data.Caption);
                    state.h2.textContent = $dyn.value(data.TitleFields);
                    state.h2.setAttribute("aria-hidden", $dyn.value(data.TitleFields) ? "false" : "true");
                }
            };
            FormHeaderCreateBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state) {
                    if (state.mutationObserver) {
                        state.mutationObserver.disconnect();
                    }
                    if (state.h1) {
                        $(state.h1).off();
                    }
                }
            };
            return FormHeaderCreateBindingHandler;
        }());
        bindingHandlers.formHeaderCreate = new FormHeaderCreateBindingHandler();
        /**
         * Wrapper for $dyn.superTooltip functionality.
         * Fires on the mouseenter event as the mouseleave event is handled by the QTip.
         * @internal
         */
        var SuperTooltipBindingHandler = /** @class */ (function () {
            function SuperTooltipBindingHandler() {
            }
            SuperTooltipBindingHandler.prototype.setup = function (targetElement, data) {
                if (data) {
                    targetElement.setAttribute("dyn-data-supertooltip", "true");
                }
            };
            SuperTooltipBindingHandler.prototype.invoke = function (targetElement, data) {
                if (data) {
                    $(targetElement).on("mouseenter", $dyn.onMouseEvent.callMouseEnterFunction);
                    $(targetElement).on("keydown", $dyn.onKeyDownEvent.callKeyDownFunction);
                    $(targetElement).on("focus", $dyn.onFocusEvent.callFocusInFunction);
                    $(targetElement).on("blur", $dyn.onFocusEvent.callFocusOutFunction);
                }
                else {
                    targetElement.removeAttribute("dyn-data-supertooltip");
                    $dyn.onMouseEvent.clearMouseEvents(targetElement);
                    $(targetElement).off("keydown", $dyn.onKeyDownEvent.callKeyDownFunction);
                    $dyn.onFocusEvent.clearFocusEvents(targetElement);
                }
            };
            SuperTooltipBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                // Only invoke for truthy values.
                // TODO TFS:3745038 Bug? Don't update on new falsey and old truthy values?
                if (!newValue || (newValue && lastValue)) {
                    return false;
                }
                return true;
            };
            SuperTooltipBindingHandler.prototype.dispose = function (targetElement) {
                targetElement.removeAttribute("dyn-data-supertooltip");
                $dyn.onMouseEvent.clearMouseEvents(targetElement);
                $(targetElement).off("keydown", $dyn.onKeyDownEvent.callKeyDownFunction);
                $dyn.onFocusEvent.clearFocusEvents(targetElement);
            };
            return SuperTooltipBindingHandler;
        }());
        bindingHandlers.superTooltip = new SuperTooltipBindingHandler();
        /**
         * Creates an image.
         * @internal
         */
        var ImageBindingHandler = /** @class */ (function () {
            function ImageBindingHandler() {
            }
            ImageBindingHandler.prototype.setup = function () {
                return { lastImageClass: "" };
            };
            ImageBindingHandler.prototype.invoke = function (targetElement, data, lastValue, state) {
                var imageClass;
                var attributeToAdd = "";
                var img;
                var createimage = function (source, alt) {
                    img = document.createElement("img");
                    img.setAttribute("src", source);
                    img.classList.add("imageBinder-image");
                    targetElement.appendChild(img);
                    // Remove any height and width attributes that may have been added.
                    // We should be sizing using css width and height anyway.
                    // This is done to work around an issue in IE where it caches and
                    // applies size attributes to images automatically.
                    img.removeAttribute("width");
                    img.removeAttribute("height");
                    if (alt) {
                        img.setAttribute("alt", alt);
                        targetElement.setAttribute("title", alt);
                    }
                    else {
                        var controlName_1 = ($dyn.context(targetElement) && $dyn.context(targetElement).Name) || "";
                        alt = $dyn.label("Framework_No_Alt_Text") + " " + controlName_1;
                        img.setAttribute("alt", alt);
                    }
                };
                // Clear out anything that might have been previously added.
                // Add any borders back incase they are needed again.
                targetElement.classList.remove("imageBinder-emptyImage");
                targetElement.removeAttribute("data-dyn-image-type");
                targetElement.removeAttribute("title");
                // Remove any existing children and content.
                $dyn.util.empty(targetElement);
                // Remove the css class stored for the previously used image.
                if (state && state.lastImageClass) {
                    targetElement.classList.remove(state.lastImageClass);
                }
                imageClass = "imageBinder-emptyImage";
                attributeToAdd = "";
                // Add the css properties or css classes to represent the new image.
                if (data && data.imageName) {
                    var controlLabel = ($dyn.context(targetElement) && $dyn.context(targetElement).Label) || null;
                    switch (data.imageType) {
                        case $dyn.ui.ImageType.symbol:
                            // Add the required sufix to create the css classname for the symbol.
                            if (!data.imageName.match(/\s+/g)) {
                                imageClass = data.imageName + "-symbol";
                                attributeToAdd = "Symbol";
                            }
                            if (data.altText) {
                                // For symbols set the title instead of the alt text. this will drive tool tip
                                targetElement.setAttribute("title", data.altText);
                            }
                            // For symbols if no label and no altText set to aria-hidden so readers skip it
                            if (!controlLabel && !data.altText) {
                                targetElement.setAttribute("aria-hidden", "true");
                            }
                            break;
                        case $dyn.ui.ImageType.url:
                        case $dyn.ui.ImageType._axResource:
                            createimage(data.imageName, data.altText);
                            imageClass = "";
                            attributeToAdd = "Image";
                            break;
                        case $dyn.ui.ImageType.base64:
                            createimage("data:image/png;base64," + data.imageName, data.altText);
                            imageClass = "";
                            attributeToAdd = "Image";
                            break;
                    }
                }
                // Used for next function call
                if (imageClass) {
                    state.lastImageClass = imageClass;
                    targetElement.classList.add(imageClass);
                }
                if (attributeToAdd) {
                    targetElement.setAttribute("data-dyn-image-type", attributeToAdd);
                }
            };
            return ImageBindingHandler;
        }());
        bindingHandlers.ImageBindingHandler = ImageBindingHandler;
        bindingHandlers.img = new ImageBindingHandler();
        /**
         * Sets the image font size
         * @internal
         */
        var ImageFontSizeBindingHandler = /** @class */ (function () {
            function ImageFontSizeBindingHandler() {
            }
            ImageFontSizeBindingHandler.prototype.invoke = function (targetElement, data) {
                // Based on the image type and if it is in a grid, change the size of the text appropriately.
                if (data && "imageType" in data) {
                    if (data.imageType === "Symbol" && !data.inGrid) {
                        // tslint:disable-next-line:radix
                        var height_1 = parseInt(data.height);
                        // tslint:disable-next-line:radix
                        var width_1 = parseInt(data.width);
                        var heightIsNumber = !isNaN(height_1);
                        var widthIsNumber = !isNaN(width_1);
                        if (heightIsNumber || widthIsNumber) {
                            // If either dimension is not specified, and the other is, the default for the unspecified dimension should be 0.
                            // We expect that the developer should specify both dimensions if they are using a manual size.
                            // When height/width are not manual, the height/width of the symbol will be equal to the default size specified in CSS.
                            var fontSize = 0;
                            var lineHeight = 0;
                            if (heightIsNumber && widthIsNumber) {
                                // Font size should be scaled to the available space.
                                fontSize = 0.4 * Math.min(height_1, width_1);
                                lineHeight = height_1;
                            }
                            $(targetElement)
                                .css("line-height", lineHeight + "px")
                                .css("font-size", fontSize + "px");
                        }
                        else {
                            $(targetElement)
                                .css("line-height", "")
                                .css("font-size", "");
                        }
                    }
                    else {
                        $(targetElement)
                            .css("line-height", "")
                            .css("font-size", "");
                    }
                }
            };
            ImageFontSizeBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                if (!newValue || (newValue && lastValue && newValue.height === lastValue.height && newValue.imageType === lastValue.imageType && newValue.width === lastValue.width)) {
                    return false;
                }
                return true;
            };
            return ImageFontSizeBindingHandler;
        }());
        bindingHandlers.imgFontSize = new ImageFontSizeBindingHandler();
        /**
         * @extcontrol
         * Handles the rendering of controls with multiple children.
         */
        var ForeachBindingHandler = /** @class */ (function () {
            function ForeachBindingHandler() {
                // Set unwrapObservable to false to enable the framework to send in the data
                // as an observable instead of unwrapping and sending a value
                this.unwrapObservable = false;
                /** Performance task for the overall foreach handler */
                this.task = $dyn.debug.performance ? new $dyn.PerformanceTask("foreach") : null;
                /** Performance task for each foreach item */
                this.itemTask = $dyn.debug.verboseForeach ? new $dyn.PerformanceTask("foreachItem") : null;
                // Bind callbacks
            }
            ForeachBindingHandler.prototype.setup = function (targetElement) {
                // In addition to setting up the state, configure the template to use for the children.
                var state = {
                    appliedBinding: false,
                    lastValue: undefined,
                    listObserver: undefined,
                    // tslint:disable-next-line:object-literal-sort-keys
                    list: undefined,
                    disposed: false,
                    collection: undefined,
                    reuseItems: false,
                    getIdentifier: undefined,
                    getVersion: undefined,
                    foreachObserver: undefined,
                    renderForEachTask: this.task,
                    deferred: undefined,
                    preRender: undefined,
                    postRender: undefined,
                    updating: undefined,
                    template: undefined,
                    setAriaAttributes: true,
                    iterationCallback: undefined,
                };
                // The template to use for the binding may have been cached before
                // TODO TFS:3745038 Follow $target naming convention
                var target = $(targetElement);
                state.template = targetElement.dynForeachTemplate;
                if (!state.template) {
                    // Current children are used as template
                    state.template = target.children();
                    state.template.attr($dyn.Const.stopBindingAttribute, "true");
                    targetElement.dynForeachTemplate = state.template;
                    $dyn.util.empty(targetElement);
                }
                state.context = $dyn.context(targetElement);
                return state;
            };
            ForeachBindingHandler.prototype.applyForeach = function (currentElement, state) {
                if (state.disposed) {
                    $dyn.log.foreach && $dyn.log.foreach.error("Foreach: Apply after dispose error");
                }
                var target = $(currentElement);
                var itemTask = this.itemTask;
                var createCoreRow = this.createCoreRow;
                var setAttributes = this.setAttributes;
                var removeCoreRow = this.removeCoreRow;
                var role = $dyn.role(currentElement);
                var dataContext = role.context;
                if (dataContext && !(dataContext instanceof $dyn.DataContext)) {
                    throw new TypeError("The argument 'dataContext' must be a an instance of $dyn.DataContext");
                }
                var createConfiguration = {
                    dataContext: dataContext,
                    role: role,
                    template: state.template,
                };
                var collection = $dyn.value(state.collection);
                if (collection !== null && collection !== undefined) {
                    if (currentElement.dynForeachBinding) {
                        $dyn.log.foreach && $dyn.log.foreach("Foreach: Binding already pending");
                    }
                    if (state.getIdentifier && typeof state.getIdentifier !== "function") {
                        throw new TypeError("The argument 'getIdentifier' must be a function");
                    }
                    currentElement.dynForeachBinding = true;
                    var currentFragment_1 = document.createDocumentFragment();
                    var currentInsertAfterElement_1 = null;
                    var documentFragments_1 = [currentFragment_1];
                    var insertAfterElements_1 = [currentInsertAfterElement_1];
                    var createNewFragmentIfNeeded_1 = function () {
                        if (!currentFragment_1) {
                            currentFragment_1 = document.createDocumentFragment();
                            documentFragments_1.push(currentFragment_1);
                            insertAfterElements_1.push(currentInsertAfterElement_1);
                        }
                    };
                    var renderForeach = function () {
                        // Don't allow foreach to become re-entrant. This can happen in obscure cases where the constructor for a
                        // newly rendered child control modifies an observable and this observable triggers a computed scope that invokes the foreach.
                        // Triggering this kind of relationship is quite unusual during control construction and adding this check basically assumes that the
                        // process of rendering a collection will not actually impact the collection itself, and so any re-render requests are ignored.
                        if (!state.rendering) {
                            state.rendering = true;
                            var startTime = void 0;
                            if ($dyn.log.performance) {
                                startTime = performance.now();
                            }
                            state.renderForEachTask && state.renderForEachTask.start();
                            if (!(state.reuseItems && collection.length && state.lastValue)) {
                                // Clear existing children
                                $dyn.util.empty(currentElement);
                                state.lastValue = undefined;
                            }
                            if (collection) {
                                var wasUpdatingSet = void 0;
                                if (state.deferred) {
                                    wasUpdatingSet = false;
                                    if (!$dyn.peek($dyn.ui.updating)) {
                                        $dyn.ui.updating(true);
                                        wasUpdatingSet = true;
                                    }
                                    // Only defer on initial render. Subsequent renders for create, etc., should be performed immediately
                                    // so that there are minimal delays, focus is maintained and all binding handlers are operating against
                                    // the final instance of the row.
                                    state.deferred = false;
                                }
                                var layoutBlockSet = $dyn.ui.layout();
                                if (!layoutBlockSet) {
                                    /// Put the handler into an updating block so that newly created children in the grid with layout bindings will be batched so that only the
                                    /// topmost element gets laid out at the end.
                                    $dyn.ui.layout(true);
                                }
                                if (state.template[0]) {
                                    var arrayLength = collection.length;
                                    // The object that is going to be filled with new rendered rows data
                                    // 1) elements - an object that maps id of an item to rendered DOM element
                                    // 2) orders - an object that maps id of an item to an order in which this element was rendered
                                    var newRenderedRows = { elements: {}, orders: {}, versions: {} };
                                    var elementsById = undefined;
                                    var orders = undefined;
                                    var versions = undefined;
                                    var lastReusedOrder = -1;
                                    if (state.lastValue) {
                                        elementsById = state.lastValue.elements;
                                        orders = state.lastValue.orders;
                                        versions = state.lastValue.versions;
                                    }
                                    for (var arrayIndex = 0, instance = void 0, gap = 0; arrayIndex < arrayLength; arrayIndex++) {
                                        itemTask && itemTask.start(arrayIndex.toString());
                                        if (state.reuseItems) {
                                            var itemId = state.getIdentifier(collection[arrayIndex]);
                                            // Version is optional
                                            var currentVersion = $dyn.callFunction(state.getVersion, state, collection[arrayIndex]);
                                            var elementToReuse = elementsById && elementsById[itemId];
                                            var lastVersion = versions && versions[itemId];
                                            if (newRenderedRows.elements[itemId]) {
                                                $dyn.logError("Foreach: Duplicate itemId: %s, position=%s/%s", itemId, newRenderedRows.orders[itemId], arrayIndex);
                                                // Skip the duplicate
                                                continue;
                                            }
                                            if (!elementToReuse || lastVersion !== currentVersion) {
                                                createNewFragmentIfNeeded_1();
                                                instance = createCoreRow(collection[arrayIndex], arrayIndex, arrayLength, createConfiguration);
                                            }
                                            else {
                                                var elementsOrder = orders[itemId];
                                                if (elementsOrder > lastReusedOrder) {
                                                    // We are reusing an element in correct order (There were no other element reused after this)
                                                    // As we are reusing an element we have to 'close' the document fragment
                                                    currentFragment_1 = null;
                                                    currentInsertAfterElement_1 = elementToReuse;
                                                    lastReusedOrder = elementsOrder;
                                                }
                                                else {
                                                    // In this case an element has incorrect order relatively to last reused element
                                                    // We will add it to document fragment
                                                    createNewFragmentIfNeeded_1();
                                                }
                                                instance = elementToReuse;
                                                elementsById[itemId] = undefined;
                                                orders[itemId] = undefined;
                                                versions[itemId] = undefined;
                                            }
                                            newRenderedRows.elements[itemId] = instance;
                                            newRenderedRows.orders[itemId] = arrayIndex;
                                            newRenderedRows.versions[itemId] = currentVersion;
                                        }
                                        else {
                                            instance = createCoreRow(collection[arrayIndex], arrayIndex, arrayLength, createConfiguration);
                                        }
                                        instance && setAttributes(instance, arrayIndex, arrayLength, state.setAriaAttributes);
                                        if (currentFragment_1 && instance) {
                                            currentFragment_1.appendChild(instance);
                                        }
                                        $dyn.applyFunction(state.iterationCallback, state.context, [instance, arrayIndex]);
                                        itemTask && itemTask.stop(arrayIndex.toString());
                                    }
                                    // cleanup nodes not in the new collection
                                    if (state.reuseItems && state.lastValue) {
                                        for (var i = 0, keys = Object.keys(elementsById), len = keys.length; i < len; ++i) {
                                            var oldItem = elementsById[keys[i]];
                                            if (oldItem) {
                                                removeCoreRow(currentElement, oldItem);
                                            }
                                        }
                                    }
                                    for (var i = 0, len = documentFragments_1.length; i < len; ++i) {
                                        var elementToInsertAfter = insertAfterElements_1[i];
                                        if (elementToInsertAfter) {
                                            currentElement.insertBefore(documentFragments_1[i], elementToInsertAfter.nextSibling);
                                        }
                                        else {
                                            if (i === 0 && elementToInsertAfter === null) {
                                                currentElement.insertBefore(documentFragments_1[i], currentElement.firstChild);
                                            }
                                        }
                                    }
                                    /// #DEBUG
                                    if (currentElement.childNodes.length !== arrayLength) {
                                        $dyn.logError("Foreach: Unexpected elements in DOM, element count: %s, data count: %s", currentElement.childNodes.length, arrayLength);
                                    }
                                    /// #ENDDEBUG
                                    $dyn.applyFunction(state.postRender, state.context);
                                    state.lastValue = newRenderedRows;
                                }
                                if (wasUpdatingSet) {
                                    $dyn.ui.updating(false);
                                }
                                // Need to queue the parent element for an arrange
                                currentElement.classList.contains($dyn.layout.ScopeMarker) ? $dyn.layout.queueArrange(currentElement) : $dyn.layout.queueArrange(currentElement.parentNode);
                                if (!layoutBlockSet) {
                                    $dyn.ui.layout(false);
                                }
                            }
                            state.renderForEachTask && state.renderForEachTask.stop();
                            if ($dyn.log.performance) {
                                var endTime = performance.now();
                                var name_2 = "<unknown>";
                                var context_1 = $dyn.context(currentElement);
                                if (context_1 && context_1.Name) {
                                    name_2 = context_1.Name;
                                }
                                $dyn.log.performance("Foreach: foreach render time: %s, %s, %s (ms)", name_2, currentElement.className, endTime - startTime);
                            }
                            state.rendering = false;
                        }
                        else {
                            $dyn.logError("Foreach render was invoked while in the middle of render. Verify the constructor of the object generated does not have unexpected side-effects.");
                        }
                    };
                    $dyn.applyFunction(state.preRender, state.context);
                    if (state.deferred) {
                        $dyn.async(renderForeach, undefined, "Render foreach");
                    }
                    else {
                        renderForeach();
                    }
                    state.appliedBinding = true;
                    currentElement.dynForeachBinding = false;
                }
            };
            ForeachBindingHandler.prototype.invoke = function (targetElement, data, oldValue, state) {
                var _this = this;
                var target = $(targetElement);
                state.foreachObserver = $dyn.observe(data, function (data) {
                    var unwrappedData = $dyn.value(data);
                    state.collection = unwrappedData;
                    state.reuseItems = false;
                    if (unwrappedData === null || unwrappedData === undefined) {
                        return;
                    }
                    if (!(unwrappedData instanceof Array)) {
                        state.collection = unwrappedData.collection;
                        // determines when collection is saved in lastValue and reused during renderForeach
                        state.reuseItems = unwrappedData.reuseItems;
                        // method to call to retrieve the identifier of each collection element
                        state.getIdentifier = unwrappedData.getIdentifier;
                        state.getVersion = unwrappedData.getVersion;
                        state.deferred = unwrappedData.deferred;
                        state.preRender = unwrappedData.preRender;
                        state.postRender = unwrappedData.postRender;
                        state.updating = unwrappedData.updating;
                        state.setAriaAttributes = unwrappedData.setAriaAttributes === undefined ? true : unwrappedData.setAriaAttributes;
                        state.iterationCallback = unwrappedData.iterationCallback;
                    }
                    state.list = $dyn.options(function () {
                        return {
                            collection: state.collection,
                        };
                    }, state.updating);
                    // Data is an array on which we are supposed to repeat
                    state.listObserver = $dyn.observe(state.list, function (options) {
                        targetElement.dynForeachOptions = options;
                        _this.applyForeach(targetElement, state);
                    }, undefined, state.listObserver);
                }, undefined, state.foreachObserver);
            };
            ForeachBindingHandler.prototype.dispose = function (targetElement, state) {
                $dyn.dispose(state.selectedIndexSubscription);
                $dyn.dispose(state.listObserver);
                $dyn.dispose(state.list);
                $dyn.dispose(state.foreachObserver);
                state.disposed = true;
                // unbind children if they had been bound
                if (state.appliedBinding) {
                    var target_1 = $(targetElement);
                    target_1.children().each(function (elementIndex, element) {
                        $dyn.unbind(element);
                    });
                    state.appliedBinding = false;
                }
                if (targetElement && targetElement.dynForeachOptions) {
                    targetElement.dynForeachOptions = null;
                }
            };
            /**
             * Inserts a new data-bound child.
             */
            ForeachBindingHandler.prototype.createCoreRow = function (arrayItem, arrayIndex, arrayLength, config) {
                // Make the array-item the new dataContext, add $index scope var
                var itemDataContext = new $dyn.DataContext(arrayItem, config.dataContext);
                itemDataContext.scopeVars.$index = arrayIndex;
                itemDataContext.scopeVars.$length = arrayLength;
                // Cloning the template for an instance
                var instance = config.template[0];
                instance = instance.cloneNode(true);
                // Apply data-binding to this element
                config.role.dataBindItem(instance, itemDataContext);
                return instance;
            };
            /**
             * Removes and unbinds a child element.
             */
            ForeachBindingHandler.prototype.removeCoreRow = function (targetElement, elementToRemove) {
                if (targetElement) {
                    targetElement.removeChild(elementToRemove);
                    $dyn.unbind(elementToRemove);
                    return true;
                }
                return false;
            };
            /**
             * Wrapper for three DOM attributes on the instance.
             */
            ForeachBindingHandler.prototype.setAttributes = function (instance, arrayIndex, arrayLength, setAriaAttributes) {
                instance.setAttribute("data-dyn-index", arrayIndex.toString());
                if (setAriaAttributes) {
                    instance.setAttribute("aria-posinset", (arrayIndex + 1));
                    instance.setAttribute("aria-setsize", arrayLength);
                }
            };
            return ForeachBindingHandler;
        }());
        bindingHandlers.foreach = new ForeachBindingHandler();
        /**
         * A "templated foreach"
         * @internal
         * @see $dyn.bindingHandlers.foreach for additional information.
         * @param targetElement
         * @param role
         */
        bindingHandlers.inlineForeach = function (targetElement) {
            var inlineTask = $dyn.bindingHandlers.foreach.task;
            // Note: inline foreach is now more of a "templated foreach" (a template aware foreach), the name may change in the future
            var target = $(targetElement);
            // The template to use for the binding may have been cached before
            var template = targetElement.dynForeachTemplate;
            var templateParentElement = $dyn.templatedParentElement(targetElement);
            if (!templateParentElement) {
                templateParentElement = targetElement.parentNode;
            }
            if (templateParentElement && !templateParentElement.dynChildren) {
                $dyn.makeContainer(templateParentElement);
            }
            var parentRole = $dyn.role(templateParentElement);
            var children = $dyn._getChildren(templateParentElement);
            var appliedBinding = false;
            if (!template) {
                // Current children are used as template
                template = target.children();
                template.attr($dyn.Const.stopBindingAttribute, "true");
                targetElement.dynForeachTemplate = template;
                target.detach();
                templateParentElement.templatedForeach = targetElement;
            }
            return {
                apply: function (data, dataContext) {
                    // Data is an array on which we are supposed to repeat
                    if (data) {
                        $dyn.observe(data, function inlineForeach_dataChanged(data) {
                            if (data) {
                                var results = [];
                                inlineTask && inlineTask.start();
                                var list = $();
                                children().length = 0;
                                if (template[0]) {
                                    for (var dataIndex = 0, len = data.length; dataIndex < len; dataIndex++) {
                                        // Cloning the template for an innstance
                                        var instance = template[0].cloneNode(true);
                                        // Add the instance as a child
                                        list = list.add(instance);
                                        children.set(dataIndex, instance);
                                    }
                                    children.valueChanged.raise();
                                    for (var elementIndex = 0, len = list.length; elementIndex < len; elementIndex++) {
                                        var item = list[elementIndex];
                                        var arrayItem = data[elementIndex];
                                        // Make the array-item the new dataContext, add $index scope var
                                        var itemDataContext = new $dyn.DataContext(arrayItem, dataContext);
                                        var scopeVars = itemDataContext.scopeVars;
                                        scopeVars.$index = elementIndex;
                                        scopeVars.$length = len;
                                        parentRole.dataBindItem(item, itemDataContext);
                                    }
                                    // TODO: Should server form do this after data bind as? Pivots would want this done after data bind.
                                    if ($dyn.context(templateParentElement)) {
                                        $dyn.context(templateParentElement).Children.valueChanged.raise();
                                    }
                                }
                                inlineTask && inlineTask.stop();
                            }
                        });
                        appliedBinding = true;
                    }
                },
                setup: function () {
                    // unbind children if they had been bound
                    if (appliedBinding) {
                        target.children().each(function (elementIndex, element) {
                            $dyn.unbind(element);
                        });
                        if (targetElement.dynForeachTemplate) {
                            targetElement.dynForeachTemplate = null;
                        }
                        if (templateParentElement && templateParentElement.templatedForeach) {
                            templateParentElement.templatedForeach = null;
                        }
                        appliedBinding = false;
                    }
                },
            };
        };
        // TODO TFS:3745038 Change to standard $dyn.bindingHandlers.if
        /**
         * @extcontrol
         * Conditionally databind the children.
         */
        var IfBindingHandler = /** @class */ (function () {
            function IfBindingHandler() {
            }
            /**
             * Called once during the initial binding of the Element.
             *
             * It is allowable to pass in undefined for this handler.
             * Due the the framework default the oldValue to undefined on the first run,shouldInvoke may not run when the first invocation should occur.
             * Force the invoke later if necessary.
             *
             * @param targetElement The HTML Element.
             * @param firstValue The first value.
             */
            IfBindingHandler.prototype.setup = function (targetElement, data) {
                // Sometimes users of this handler pass in 'undefined' as a valid parameter for the first time
                // The framework defaults lastValue to 'undefined' which will cause the default shouldInvoke to not invoke
                // We will override the first 'shouldInvoke' call to force the invoke for the first new undefined
                return { appliedBinding: false, shouldForceInvoke: data === undefined };
            };
            IfBindingHandler.prototype.invoke = function (targetElement, data, oldValue, state) {
                // The template to use for the binding may have been cached before
                var template = state.template;
                if (!template) {
                    // Current children are used as template
                    template = $(targetElement).children();
                    state.template = template;
                }
                // TODO: perf - shouldn't have to detach the first time.
                template.detach();
                // Data is a value that we need to test for true
                if (data && data !== "false") {
                    var role_1 = $dyn.role(targetElement);
                    var dataContext_1 = role_1.context;
                    template.attr($dyn.Const.stopBindingAttribute, "true");
                    // Apply the data-binding on the instance
                    template.each(function (elementIndex, element) {
                        // Apply data-binding to this element
                        var childRole = role_1.getChildRole(element);
                        if (!childRole._getIsDataBound()) {
                            role_1.dataBindChild(element, dataContext_1);
                        }
                    });
                    // Add the instance as a child
                    $(targetElement).append(template);
                    state.appliedBinding = true;
                }
            };
            IfBindingHandler.prototype.dispose = function (targetElement, state) {
                // unbind children if they had been bound
                if (state.appliedBinding) {
                    var template = state.template;
                    if (template) {
                        template.each(function (elementIndex, element) {
                            $dyn.unbind(element);
                        });
                    }
                    state.appliedBinding = false;
                }
            };
            IfBindingHandler.prototype.shouldInvoke = function (newValue, oldValue, state) {
                if (state.shouldForceInvoke) {
                    // Set back to false because oldValue will now be current
                    // Force the first 'undefined' invoke
                    state.shouldForceInvoke = false;
                    return true;
                }
                return newValue !== oldValue;
            };
            return IfBindingHandler;
        }());
        bindingHandlers.conditional = new IfBindingHandler();
        // Required for back compat
        $dyn.bindingHandlers.if = bindingHandlers.conditional;
        /**
         * @deprecated
         */
        // TODO TFS:3745038 Dead. Needs Tests.htm cleanup
        bindingHandlers.inlineIf = function (targetElement) {
            $dyn.logDeprecated("$dyn.bindingHandlers.inlineIf");
            var templateParentElement = $dyn.templatedParentElement(targetElement);
            if (!templateParentElement && targetElement.parentNode) {
                templateParentElement = targetElement.parentNode;
                $dyn.makeContainer(templateParentElement);
            }
            var parentRole = $dyn.role(templateParentElement);
            var children = $dyn._getChildren(templateParentElement);
            var movedChildren = false;
            var appliedBinding = false;
            var contents = targetElement.dynIfContents;
            if (!contents) {
                contents = $(targetElement).children();
                targetElement.dynIfContents = contents;
                contents.attr($dyn.Const.stopBindingAttribute, "true");
            }
            $(targetElement).hide();
            return {
                apply: function (data, dataContext) {
                    // Data is a value that we need to test for true
                    var ifIndex = $dyn.value(children).indexOf(targetElement);
                    if (ifIndex >= 0) {
                        if (data === true) {
                            if (!movedChildren) {
                                // Splice takes a var args of items to remove (not an array).
                                var args = $.merge([ifIndex + 1, 0], contents);
                                children.splice.apply(children, args);
                                movedChildren = true;
                                children.valueChanged.raise();
                                if (!appliedBinding) {
                                    // Apply the data-binding on the instance
                                    contents.each(function (elementIndex, element) {
                                        // Apply data-binding to this element
                                        var childRole = $dyn.role(element);
                                        if (!childRole.isDataBound()) {
                                            parentRole.dataBindChild(element, dataContext);
                                        }
                                    });
                                    appliedBinding = true;
                                }
                            }
                        }
                        else {
                            if (movedChildren) {
                                // Doesn't assume that the children have remained in the orig order.
                                contents.each(function (elementIndex, element) {
                                    var childIndex = $dyn.value(children).indexOf(element);
                                    if (childIndex >= 0) {
                                        children.splice(childIndex, 1);
                                    }
                                });
                                children.valueChanged.raise();
                                movedChildren = false;
                            }
                            else {
                                contents.detach();
                            }
                        }
                    }
                    else {
                        throw new Error("Inline-if: Target element is not in the child array of its parent. TargetElement: " + targetElement);
                    }
                },
                setup: function () {
                    // unbind children if they had been bound
                    if (appliedBinding) {
                        contents.each(function (elementIndex, element) {
                            $dyn.unbind(element);
                        });
                        appliedBinding = false;
                    }
                },
            };
        };
        /**
         * Used only by Dialog.
         * @internal
         */
        var DialogSizeBindingHandler = /** @class */ (function () {
            function DialogSizeBindingHandler() {
            }
            DialogSizeBindingHandler.prototype.setup = function () {
                return { lastValue: undefined };
            };
            DialogSizeBindingHandler.prototype.invoke = function (targetElement, data, oldValue, state) {
                if (data) {
                    if (state.lastValue !== undefined) {
                        targetElement.classList.remove(state.lastValue);
                    }
                    if (data === $dyn.ui.DialogSize.small) {
                        state.lastValue = "dialogSize-small";
                        targetElement.classList.add("dialogSize-small");
                    }
                    else if (data === $dyn.ui.DialogSize.medium) {
                        state.lastValue = "dialogSize-medium";
                        targetElement.classList.add("dialogSize-medium");
                    }
                    else if (data === $dyn.ui.DialogSize.large) {
                        state.lastValue = "dialogSize-large";
                        targetElement.classList.add("dialogSize-large");
                    }
                    else if (data === $dyn.ui.DialogSize.full) {
                        state.lastValue = "dialogSize-full";
                        targetElement.classList.add("dialogSize-full");
                    }
                }
            };
            DialogSizeBindingHandler.prototype.shouldInvoke = function (newValue, lastValue) {
                return newValue && newValue !== lastValue;
            };
            return DialogSizeBindingHandler;
        }());
        bindingHandlers.DialogSizeBindingHandler = DialogSizeBindingHandler;
        bindingHandlers.dialogSize = new DialogSizeBindingHandler();
        /**
         * Wrapper for $dyn.ui.Control.DisplayOptions.
         * @internal
         */
        var DisplayOptionsBindingHandler = /** @class */ (function () {
            function DisplayOptionsBindingHandler() {
            }
            DisplayOptionsBindingHandler.prototype.shouldInvoke = function (value, lastValue) {
                if (value && lastValue) {
                    return (value.useBackColor !== lastValue.useBackColor ||
                        value.useTextColor !== lastValue.useTextColor ||
                        value.fontWeight !== lastValue.fontWeight ||
                        value.textDecoration !== lastValue.textDecoration ||
                        value.backcolor !== lastValue.backcolor ||
                        value.textcolor !== lastValue.textcolor ||
                        value.useColorOnSelectedRow !== lastValue.useColorOnSelectedRow);
                }
                return !lastValue && !!value;
            };
            DisplayOptionsBindingHandler.prototype.invoke = function (targetElement, newValue) {
                var applyDisplayOption = false;
                if (newValue && Object.keys(newValue).length !== 0) {
                    // 3734056: Don't update display options for text foreground/background in selected grid rows
                    var controlContext = $dyn.context(targetElement); // Inactive rows do not have a control context
                    var forceColorAlways = newValue.useColorOnSelectedRow && newValue.useColorOnSelectedRow === "true";
                    // reset color
                    if (newValue.backcolor) {
                        targetElement.style.backgroundColor = "transparent";
                    }
                    if (newValue.textcolor) {
                        targetElement.style.color = "inherit";
                    }
                    if (!controlContext || !controlContext.isInSelectedGridRow() || (controlContext.isInSelectedGridRow() && forceColorAlways)) {
                        // Background color if selected row and use color - or if not selected and color is set
                        if ((newValue.useBackColor && newValue.useBackColor === "true" && newValue.backcolor) || forceColorAlways) {
                            // tslint:disable-next-line:no-bitwise
                            var r = (newValue.backcolor & 0xff0000) >> 16;
                            // tslint:disable-next-line:no-bitwise
                            var g = (newValue.backcolor & 0xff00) >> 8;
                            // tslint:disable-next-line:no-bitwise
                            var b = newValue.backcolor & 0xff;
                            var rgbaColorVal = "rgb(" + r + "," + g + "," + b + ")";
                            targetElement.style.backgroundColor = rgbaColorVal;
                            applyDisplayOption = true;
                        }
                        else {
                            targetElement.style.backgroundColor = "inherit";
                        }
                        // Font color
                        if ((newValue.useTextColor && newValue.useTextColor === "true" && newValue.textcolor) || forceColorAlways) {
                            // tslint:disable-next-line:no-bitwise
                            var r = (newValue.textcolor & 0xff0000) >> 16;
                            // tslint:disable-next-line:no-bitwise
                            var g = (newValue.textcolor & 0xff00) >> 8;
                            // tslint:disable-next-line:no-bitwise
                            var b = newValue.textcolor & 0xff;
                            targetElement.style.color = "rgb(" + r + ", " + g + ", " + b + ")";
                            applyDisplayOption = true;
                        }
                        else {
                            targetElement.style.color = "inherit";
                        }
                    }
                    // Font bold
                    if (newValue.fontWeight && newValue.fontWeight === "true") {
                        targetElement.style.fontWeight = "bold";
                        applyDisplayOption = true;
                    }
                    else {
                        targetElement.style.fontWeight = "";
                    }
                    // Font italic
                    if (newValue.fontStyle && newValue.fontStyle === "true") {
                        targetElement.style.fontStyle = "italic";
                        applyDisplayOption = true;
                    }
                    else {
                        targetElement.style.fontStyle = "";
                    }
                    // Underline
                    if (newValue.textDecoration) {
                        targetElement.style.textDecoration = newValue.textDecoration;
                        applyDisplayOption = true;
                    }
                    else {
                        targetElement.style.textDecoration = "";
                    }
                }
                if (applyDisplayOption && !targetElement.classList.contains("field-displayOption")) {
                    targetElement.classList.add("field-displayOption");
                }
                else if (!applyDisplayOption && targetElement.classList.contains("field-displayOption")) {
                    targetElement.classList.remove("field-displayOption");
                }
            };
            return DisplayOptionsBindingHandler;
        }());
        bindingHandlers.DisplayOptionsBindingHandler = DisplayOptionsBindingHandler;
        bindingHandlers.displayOptions = new DisplayOptionsBindingHandler();
        var ColorBindingHandler = /** @class */ (function () {
            function ColorBindingHandler(cssAttributeName) {
                this.cssAttributeName = cssAttributeName;
            }
            ColorBindingHandler.prototype.invoke = function (targetElement, newValue) {
                if (newValue === "" || newValue === undefined) {
                    if ($(targetElement).css(this.cssAttributeName)) {
                        $(targetElement).css(this.cssAttributeName, "");
                    }
                }
                else {
                    $(targetElement).css(this.cssAttributeName, this.getRGBValues(newValue));
                }
            };
            /**
             * @internal
             * @example Convert "44 22 42" to "rgb(44,22,42)"
             * @param newValue
             */
            ColorBindingHandler.prototype.getRGBValues = function (newValue) {
                var rgbValues = newValue.split(" ", 3);
                var r = rgbValues[0];
                var g = rgbValues[1];
                var b = rgbValues[2];
                var rgbColorValues = "rgb(" + r + "," + g + "," + b + ")";
                return rgbColorValues;
            };
            return ColorBindingHandler;
        }());
        bindingHandlers.ColorBindingHandler = ColorBindingHandler;
        /**
         * Wrapper for $dyn.ui.Control.BackgroundColor.
         * @internal
         */
        bindingHandlers.backgroundColor = new ColorBindingHandler("background-color");
        /**
         * Wrapper for $dyn.ui.Control.ForegroundColor.
         * @internal
         */
        bindingHandlers.foregroundColor = new ColorBindingHandler("color");
        /**
         * Handles callbacks and focus management around the control boundary.
         * @internal
         */
        var BoundaryFocusBindingHandler = /** @class */ (function () {
            function BoundaryFocusBindingHandler() {
            }
            BoundaryFocusBindingHandler.prototype.shouldInvoke = function () {
                return true;
            };
            // TODO TFS:3745038 Remove unused params.
            BoundaryFocusBindingHandler.prototype.invoke = function (targetElement, newValue, oldValue, state) {
                state.enabled = newValue.enabled;
                state.showFlyout = newValue.showFlyout;
            };
            // TODO TFS:3745038 At least save the jQuery object
            // TODO TFS:3745038 Remove unused params.
            BoundaryFocusBindingHandler.prototype.setup = function (targetElement, data) {
                var state = { enabled: true };
                if ($.isPlainObject(data)) {
                    state.showFlyout = data.showFlyout;
                    if (data.enabled !== undefined) {
                        state.enabled = data.enabled;
                    }
                    state.focusOutCallbackFunc = data.focusOutCallBack;
                    state.focusInCallbackFunc = data.focusInCallBack;
                }
                var focusCorrectionTimeoutId;
                var allowBodyFocusCorrection;
                state.onFocusIn = function (event) {
                    allowBodyFocusCorrection = true;
                    if (focusCorrectionTimeoutId) {
                        window.clearTimeout(focusCorrectionTimeoutId);
                    }
                    focusCorrectionTimeoutId = window.setTimeout(function () {
                        allowBodyFocusCorrection = false;
                    }, 300); // 300 was an arbitrary choice
                    if ($dyn.value(state.enabled) === false) {
                        $dyn.log.focus && $dyn.log.focus("Boundary Focus: gaining focus not enabled %s calling callback", targetElement.id);
                        state.focusInCallbackFunc.apply($dyn.context(targetElement), [event]);
                        return;
                    }
                    var destinatonTargetElement = document.activeElement;
                    if (event && event.target) {
                        destinatonTargetElement = event.target;
                    }
                    if (event) {
                        if ($(destinatonTargetElement).closest(targetElement).length > 0) {
                            // if the element that triggered the focus in is one we should skip call focus out on the target as we no longer have focus
                            if ($(destinatonTargetElement).hasClass("boundary-focus-skip")) {
                                $(targetElement).trigger("focusout");
                                targetElement.setAttribute("data-dyn-boundary-focused", "false");
                            }
                            else {
                                targetElement.setAttribute("data-dyn-boundary-focused", "true");
                            }
                        }
                    }
                    if ((targetElement.getAttribute("data-dyn-boundary-focused") === "true" || $dyn.value(state.showFlyout)) && state.focusInCallbackFunc) {
                        $dyn.log.focus &&
                            $dyn.log.focus("Boundary Focus: gaining focus from %s to %s and browser's active element is %s", targetElement.id, destinatonTargetElement && destinatonTargetElement.id, document.activeElement ? document.activeElement.id : "");
                        state.focusInCallbackFunc.apply($dyn.context(targetElement), [event]);
                    }
                };
                state.onFocusOut = function (event) {
                    $dyn.log.focus && $dyn.log.focus("Boundary Focus: onFocusOut callback called from %s", targetElement.id);
                    // destinatonTargetElement the element that got focus triggering the focus out event
                    var destinatonTargetElement = document.activeElement;
                    if (event && event.relatedTarget) {
                        destinatonTargetElement = event.relatedTarget;
                    }
                    // Blocking div steals focus on blocking operation since we do not want user to interact with the UI.
                    // The flyout may temporarily lose focus if server interactions are generated after opening the flyout.
                    // Since the blocking div takes away the focus, the call back is executed when it should have been ignored.
                    if (destinatonTargetElement && destinatonTargetElement === $dyn.shell.blockingDiv) {
                        return;
                    }
                    // Focus going to the body could be due to a browser error and the end user could experience a loss of focus
                    if (destinatonTargetElement === document.body || destinatonTargetElement === null) {
                        // If we are within the 300 ms of the focusIn and our explicit js code is not causing the blur, re-focus the element.
                        if (allowBodyFocusCorrection && $dyn.shell.bodyFocusCorrection) {
                            $dyn.log.focus &&
                                $dyn.log.focus("Boundary Focus: losing focus to body, resetting focus to control %s", targetElement ? targetElement.getAttribute("data-dyn-controlname") : "");
                            $dyn.util.focusElement(targetElement);
                            return;
                        }
                        else if (!$dyn.shell.bodyFocusCorrection) {
                            $dyn.log.focus && $dyn.log.focus("Boundary Focus: losing focus to body, but not resetting because the body focus was on purpose");
                        }
                        else {
                            // This is when allowBodyFocusCorrection == false
                            $dyn.log.focus && $dyn.log.focus("Boundary Focus: losing focus to body, but not resetting because it was outside of the correction time");
                        }
                    }
                    if ($dyn.value(state.enabled) === false) {
                        $dyn.log.focus && $dyn.log.focus("Boundary Focus: losing focus not enabled %s calling callback", targetElement.id);
                        state.focusOutCallbackFunc.apply($dyn.context(targetElement), [event]);
                        return;
                    }
                    if (event) {
                        // is the element that got focus within the element that the focus out handler fired on or the based element the boundaryFocus handler was bound to
                        if (!$(destinatonTargetElement).hasClass("boundary-focus-skip") && $(destinatonTargetElement).closest(targetElement).length > 0) {
                            targetElement.setAttribute("data-dyn-boundary-focused", "true");
                        }
                        else {
                            targetElement.setAttribute("data-dyn-boundary-focused", "false");
                        }
                    }
                    if (targetElement.getAttribute("data-dyn-boundary-focused") === "false" && (state.showFlyout === undefined || !$dyn.value(state.showFlyout)) && state.focusOutCallbackFunc) {
                        $dyn.log.focus &&
                            $dyn.log.focus("Boundary Focus: losing focus from %s to %s and browser's active element is %s", targetElement.id, destinatonTargetElement ? destinatonTargetElement.id : "", document.activeElement ? document.activeElement.id : "");
                        state.focusOutCallbackFunc.apply($dyn.context(targetElement), [event]);
                    }
                };
                if ($dyn.isObservable(state.showFlyout)) {
                    state.showFlyout.valueChanged.subscribe(function (newValue) {
                        if (!$dyn.value(state.showFlyout)) {
                            state.onFocusOut();
                        }
                        else {
                            state.onFocusIn();
                        }
                    });
                }
                $(targetElement).on("focusin", state.onFocusIn);
                $(targetElement).on("focusout", state.onFocusOut);
                return state;
            };
            BoundaryFocusBindingHandler.prototype.dispose = function (targetElement, state) {
                if (state) {
                    $(targetElement).off("focusin", state.onFocusIn);
                    $(targetElement).off("focusout", state.onFocusOut);
                }
            };
            return BoundaryFocusBindingHandler;
        }());
        bindingHandlers.boundaryFocus = new BoundaryFocusBindingHandler();
        /**
         * @deprecated
         */
        // TODO TFS:3745038 Dead
        bindingHandlers.boundaryFocusOut = {
            setup: function (targetElement, data) {
                $dyn.logDeprecated("$dyn.bindingHandlers.boundaryFocusOut");
                var callbackFunc;
                var showFlyout;
                var enabled = true;
                if ($.isPlainObject(data)) {
                    showFlyout = data.showFlyout;
                    if (data.enabled !== undefined) {
                        enabled = data.enabled;
                    }
                    callbackFunc = data.focusOutCallBack;
                }
                else if (typeof (data) === "function") {
                    callbackFunc = data.focusOutCallBack;
                }
                var onFocusOut = function (event) {
                    if (!$dyn.value(enabled)) {
                        $dyn.log.focus && $dyn.log.focus("Boundary Focus: losing focus not enabled %s calling callback", targetElement.id);
                        callbackFunc(event);
                        return;
                    }
                    // destinatonTargetElement the element that got focus triggering the focus out event
                    var destinatonTargetElement = document.activeElement;
                    if (event && event.relatedTarget) {
                        destinatonTargetElement = event.relatedTarget;
                    }
                    var isChild = false;
                    // TODO this is a temp solution. Blocking div steals focus on blocking operation since we do not want user to interact with the UI.
                    // The flyout may temporarily lose focus if server interactions are generated after opening the flyout .
                    // Since the blocking div takes away the focus , the call back is executed when it should have been ignored.
                    // (The callback closes the flyout for some controls.)
                    if (destinatonTargetElement && destinatonTargetElement === $dyn.shell.blockingDiv) {
                        return;
                    }
                    // is the element that got focus within the element that the focus out handler fired on or the based element the boundaryFocusOut handler was bound to
                    if (!$(destinatonTargetElement).hasClass("boundary-focus-skip") && $(destinatonTargetElement).closest(targetElement).length > 0) {
                        isChild = true;
                    }
                    if (!isChild && (showFlyout === undefined || !$dyn.value(showFlyout)) && callbackFunc) {
                        $dyn.log.focus &&
                            $dyn.log.focus("Boundary Focus: losing focus from %s to %s and browser's active element is %s", targetElement.id, destinatonTargetElement.id, document.activeElement ? document.activeElement.id : "");
                        callbackFunc(event);
                    }
                };
                if ($dyn.isObservable(showFlyout)) {
                    $dyn.observe(showFlyout, function (newValue) {
                        if (!newValue) {
                            onFocusOut();
                        }
                    });
                }
                $(targetElement).on("focusout", onFocusOut);
                return { onFocusOut: onFocusOut };
            },
            dispose: function (targetElement, state) {
                if (state) {
                    $(targetElement).off("focusout", state.onFocusOut);
                }
            },
        };
        /**
         * @deprecated
         */
        // TODO TFS:3745038 Dead
        bindingHandlers.boundaryFocusIn = {
            // TODO TFS:3745038 At least save the jQuery object
            setup: function (targetElement, data) {
                $dyn.logDeprecated("$dyn.bindingHandlers.boundaryFocusIn");
                var callbackFunc;
                var enabled = true;
                if ($.isPlainObject(data)) {
                    if (data.enabled !== undefined) {
                        enabled = data.enabled;
                    }
                    callbackFunc = data.focusInCallBack;
                }
                else if (typeof (data) === "function") {
                    callbackFunc = data.focusInCallBack;
                }
                function onFocusIn(event) {
                    if (!$dyn.value(enabled)) {
                        $dyn.log.focus && $dyn.log.focus("Boundary Focus: gaining focus not enabled %s calling callback", targetElement.id);
                        callbackFunc(event);
                        return;
                    }
                    var destinatonTargetElement = (event && event.target) || document.activeElement;
                    var isChild = false;
                    // TODO this is a temp solution. Blocking div steals focus on blocking operation since we do not want user to interact with the UI.
                    // The flyout may temporarily lose focus if server interactions are generated after opening the flyout .
                    // Since the blocking div takes away the focus , the call back is executed when it should have been ignored.
                    // (The callback closes the flyout for some controls.)
                    if (destinatonTargetElement && destinatonTargetElement === $dyn.shell.blockingDiv) {
                        return;
                    }
                    if ($(destinatonTargetElement).closest(targetElement).length > 0) {
                        // if the element that triggered the focus in is one we should skip call focus out on the target as we no longer have focus
                        if ($(destinatonTargetElement).hasClass("boundary-focus-skip")) {
                            $(targetElement).trigger("focusout");
                        }
                        else {
                            isChild = true;
                        }
                    }
                    if (isChild && callbackFunc) {
                        $dyn.log.focus &&
                            $dyn.log.focus("Boundary Focus: gaining focus from %s to %s and browser's active element is %s", targetElement.id, destinatonTargetElement.id, document.activeElement ? document.activeElement.id : "");
                        callbackFunc(event);
                    }
                }
                $(targetElement).on("focusin", onFocusIn);
                return { onFocusIn: onFocusIn };
            },
            // tslint:disable-next-line:object-literal-sort-keys
            dispose: function (targetElement, state) {
                if (state) {
                    $(targetElement).off("focusin", state.onFocusIn);
                }
            },
        };
        /**
         * Wrapper for the horizontal scrolling with the mousewheel.
         * Used by panorama, grid, and hierarchical grid.
         * @internal
         */
        var HorizontalScrollWithWheelBindingHandler = /** @class */ (function () {
            function HorizontalScrollWithWheelBindingHandler() {
            }
            HorizontalScrollWithWheelBindingHandler.prototype.setup = function (targetElement, data) {
                var handler = function (evt) {
                    if (!(evt.shiftKey || evt.ctrlKey || evt.metaKey || evt.defaultPrevented)) {
                        // Horizontal scrolling with the wheel requires us to handle
                        // both vertical and horizontal scroll
                        var height_2;
                        if (data.height) {
                            height_2 = data.height();
                        }
                        else {
                            height_2 = targetElement.offsetHeight;
                        }
                        var width_2;
                        if (data.width) {
                            width_2 = data.width();
                        }
                        else {
                            width_2 = targetElement.offsetWidth;
                        }
                        if (targetElement.scrollHeight > height_2) {
                            targetElement.scrollTop -= evt.wheelDelta;
                            evt.preventDefault();
                        }
                        else if (targetElement.scrollWidth > width_2) {
                            targetElement.scrollLeft -= evt.wheelDelta;
                            evt.preventDefault();
                        }
                    }
                };
                targetElement.addEventListener("mousewheel", handler);
                return handler;
            };
            HorizontalScrollWithWheelBindingHandler.prototype.dispose = function (targetElement, state) {
                targetElement.removeEventListener("mousewheel", state);
            };
            return HorizontalScrollWithWheelBindingHandler;
        }());
        bindingHandlers.horizontalScrollWithWheel = new HorizontalScrollWithWheelBindingHandler();
    })(bindingHandlers = $dyn.bindingHandlers || ($dyn.bindingHandlers = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=html-binding-handlers.js.map
